<app-header [onlineDesde]="onlineDesde"></app-header>

<!-- Tela de pausa -->
<div
  *ngIf="isPaused && !isAdmin"
  class="fixed inset-0 z-[200] flex items-center justify-center cursor-default select-none px-4"
  style="background: rgba(16,24,32,.72); backdrop-filter: blur(6px)"
>
  <div class="bg-white dark:bg-[#10283A] w-full overflow-hidden"
       style="border-radius: 24px; box-shadow: 0 24px 60px -20px rgba(16,24,32,.55)"
       [style.max-width]="emVendaCartao ? '1200px' : '460px'"
       [style.max-height]="emVendaCartao ? 'calc(100vh - 32px)' : null"
       [style.overflow-y]="emVendaCartao ? 'auto' : null">

    <div [class.flex]="emVendaCartao">
    <div class="flex flex-col items-center px-7 pt-7 pb-6"
         [class.shrink-0]="emVendaCartao"
         [style.width]="emVendaCartao ? '300px' : null"
         [style.border-right]="emVendaCartao ? '1px solid var(--flua-borda)' : null">
      <span class="rounded-full px-3 py-1 uppercase flex items-center gap-1.5"
            style="background-color: #FDF3E2; color: #8A5A0C; font-size: 11px; font-weight: 800; letter-spacing: .08em">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-3">
          <path d="M5.75 3a.75.75 0 0 0-.75.75v12.5c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V3.75A.75.75 0 0 0 7.75 3h-2Zm6.5 0a.75.75 0 0 0-.75.75v12.5c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V3.75a.75.75 0 0 0-.75-.75h-2Z"/>
        </svg>
        Atendimento pausado
      </span>

      <p class="dark:text-white" style="color: var(--brand-accent); font-size: 52px; font-weight: 800; letter-spacing: .02em;
                font-variant-numeric: tabular-nums; line-height: 1.1; margin-top: 10px">
        {{ formatPausedDuration() }}
      </p>
      <p style="font-size: 13px; color: var(--brand-muted)">
        pausado desde {{ pausadoDesde }} · {{ currentMachine }}
      </p>

      <div class="flex items-center gap-2 rounded-full px-3 py-1.5 mt-4"
           style="background-color: var(--brand-tint)">
        <span style="color: var(--brand-accent); font-size: 14px; font-weight: 700">{{ currentPauseReason }}</span>
        <button (click)="trocarMotivoPausa()" class="rounded-full px-2 py-0.5 bg-white"
                style="color: var(--brand-ink); font-size: 12px; font-weight: 600">trocar</button>
      </div>

      <!-- Dois numeros da mesma colecao que alimenta a lista -->
      <div class="w-full rounded-xl px-4 py-3 mt-5 flex flex-col gap-2"
           style="background-color: var(--brand-surface)">
        <div class="flex items-center gap-2">
          <span class="rounded-full shrink-0" style="width: 7px; height: 7px; background-color: #FF7F30"></span>
          <span style="font-size: 13px; color: var(--brand-text-soft)">
            {{ filaCresceuNaPausa ? 'Fila continua crescendo' : 'Fila sem senha nova' }}
          </span>
          <span class="ml-auto dark:text-white" style="font-size: 14px; font-weight: 800; color: var(--brand-accent)">
            {{ countPasswordsNaLista() }}
          </span>
        </div>
        <div class="flex items-center gap-2">
          <span class="rounded-full shrink-0" style="width: 7px; height: 7px; background-color: var(--brand-primary)"></span>
          <span style="font-size: 13px; color: var(--brand-text-soft)">Maior espera na fila</span>
          <span class="ml-auto dark:text-white" style="font-size: 14px; font-weight: 800; color: var(--brand-accent)">
            {{ maiorEsperaNaFilaMin }} min
          </span>
        </div>
      </div>

      <div *ngIf="emVendaCartao" class="w-full rounded-xl px-4 py-3 mt-3 flex flex-col gap-1.5"
           style="background-color: var(--brand-surface)">
        <p class="uppercase" style="font-size: 11px; font-weight: 700; color: var(--brand-muted); letter-spacing: .08em">
          Seu placar hoje
        </p>
        <div class="flex items-center">
          <span style="font-size: 13px; color: var(--brand-text-soft)">Abordagens</span>
          <span class="ml-auto dark:text-white" style="font-size: 14px; font-weight: 800; color: var(--brand-accent)">{{ placarVc?.abordagens }}</span>
        </div>
        <div class="flex items-center">
          <span style="font-size: 13px; color: var(--brand-text-soft)">Recusas</span>
          <span class="ml-auto dark:text-white" style="font-size: 14px; font-weight: 800; color: var(--brand-accent)">{{ placarVc?.recusas }}</span>
        </div>
        <div class="flex items-center">
          <span style="font-size: 13px; font-weight: 700; color: var(--brand-primary)">Vendas</span>
          <span class="ml-auto" style="font-size: 14px; font-weight: 800; color: var(--brand-primary)">{{ placarVc?.vendas }}</span>
        </div>
      </div>

      <button (click)="timerRef?.resumeTimer()"
              class="w-full text-white mt-5"
              style="height: 54px; border-radius: 14px; background-color: var(--brand-secondary); font-size: 16px; font-weight: 700;
                     box-shadow: 0 6px 18px -8px rgba(0,172,112,.9)">
        Retomar atendimento
      </button>
    </div>

    <div *ngIf="emVendaCartao" class="flex-1 min-w-0 select-text" style="background-color: var(--flua-rodape)">
      <app-venda-cartao-pausa [clinicId]="unitCode" [guiche]="guicheAtual"
                              (abordagemEncerrada)="carregarPlacarVc()"></app-venda-cartao-pausa>
    </div>
    </div>

    <div class="px-7 py-4 flex flex-col items-center gap-2"
         style="background-color: var(--brand-surface); border-top: 1px solid var(--brand-line-soft)">
      <p class="uppercase" style="font-size: 11px; font-weight: 700; color: var(--brand-muted); letter-spacing: .08em">
        Disponível durante a pausa
      </p>
      <div class="flex flex-wrap items-center justify-center gap-2">
        <button (click)="abrirMeusAtendimentos()" class="rounded-full px-4 bg-white"
                style="height: 36px; border: 1px solid var(--brand-line); color: var(--brand-ink); font-size: 13px; font-weight: 600">
          Meus Atendimentos
        </button>
        <button (click)="abrirPagamentoAvulso()" class="rounded-full px-4 bg-white"
                style="height: 36px; border: 1px solid var(--brand-line); color: var(--brand-ink); font-size: 13px; font-weight: 600">
          Pagamentos
        </button>
        <button (click)="openVerFila()" class="rounded-full px-4 bg-white"
                style="height: 36px; border: 1px solid var(--brand-line); color: var(--brand-ink); font-size: 13px; font-weight: 600">
          Fila Médico
        </button>
        <button (click)="abrirAgenda()" class="rounded-full px-4 bg-white"
                style="height: 36px; border: 1px solid var(--brand-line); color: var(--brand-ink); font-size: 13px; font-weight: 600">
          Agenda
        </button>
        <button (click)="abrirHistorico(false)" class="rounded-full px-4 bg-white"
                style="height: 36px; border: 1px solid var(--brand-line); color: var(--brand-ink); font-size: 13px; font-weight: 600">
          Histórico
        </button>
        <!-- Express so aparece quando o motivo da pausa libera -->
        <button *ngIf="allowsExpress" (click)="gerenateExpressPassword()" [disabled]="disabledButton()"
                class="rounded-full px-4 bg-white"
                style="height: 36px; border: 1px solid var(--brand-line); color: var(--brand-ink); font-size: 13px; font-weight: 600"
                [style.opacity]="disabledButton() ? '.45' : '1'"
                [style.cursor]="disabledButton() ? 'not-allowed' : 'pointer'">
          Senha Express
        </button>
        <button *ngIf="selectedCallPassword" (click)="sendToAbrirAtendimento()"
                class="rounded-full px-4 bg-white"
                style="height: 36px; border: 1px solid var(--brand-line); color: var(--brand-ink); font-size: 13px; font-weight: 600">
          Abrir Atendimento
        </button>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="isLoading"
  class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50"
>
  <!-- Spinner de carregamento -->
  <div
    class="border-gray-300 h-12 w-12 animate-spin rounded-full border-4 border-t-green-500"
  ></div>
</div>

<body
  class="min-h-screen min-w-full p-4"
  (click)="closeMenu()"
  translate="no"
>
  <div class="flex flex-col gap-2 h-[calc(100vh-2rem)] overflow-hidden">
    <div class="mt-2">

    <!-- Timer de produtividade: fora do rodizio, supervisor nao tem cadencia de
         chamada automatica. Sem caixa propria — so o modal de pausa e a logica;
         o estado aparece na barra de acoes. -->
    <div *ngIf="timerConfig.autoCallEnabled && userProfile !== 'OdontoSiM' && !isAdmin">
      <app-countdown-timer
        [totalSeconds]="timerConfig.timerSeconds"
        [autoPauseMinutes]="timerConfig.autoPauseMinutes"
        [active]="timerActive && !selectedCallPassword"
        (onTimerEnd)="onTimerEnd()"
        (onPause)="onTimerPaused($event)"
        (onResume)="onTimerResumed()"
        (onAutoPaused)="onTimerAutoPaused()">
      </app-countdown-timer>
    </div>

      <div
        class="mx-6 mb-4 flex flex-wrap items-center gap-2 bg-white dark:bg-[#10283A]"
        style="border-radius: 16px; border: 1px solid var(--flua-borda); padding: 8px 10px"
      >
        <!-- Estado do guiche -->
        <div class="flex items-center gap-3 pl-2">
          <div class="flex items-center gap-1.5">
            <span class="rounded-full" style="width: 7px; height: 7px"
                  [style.background-color]="isPaused ? '#FF7F30' : 'var(--ok)'"></span>
            <span style="font-size: 12px; font-weight: 700; color: var(--brand-accent)"
                  class="dark:text-white">
              {{ isPaused ? 'Pausado' : 'Fila aberta' }}
            </span>
          </div>

          <div *ngIf="mediaAtendimentoFormatada" style="width: 1px; height: 20px; background-color: var(--brand-line)"></div>
          <div *ngIf="mediaAtendimentoFormatada" class="flex items-center gap-1.5">
            <span style="font-size: 15px; font-weight: 800; color: var(--brand-accent); font-variant-numeric: tabular-nums"
                  class="dark:text-white">{{ mediaAtendimentoFormatada }}</span>
            <span style="font-size: 11px; color: var(--brand-muted)">média de atendimento</span>
          </div>

          <!-- Pausar so fica desabilitado com senha chamada: pausar ali mudaria o
               ciclo de CHAMADO para PAUSADO e quebraria a finalizacao -->
          <button
            *ngIf="timerConfig.autoCallEnabled && userProfile !== 'OdontoSiM' && !isAdmin && !isPaused"
            (click)="timerRef?.openPauseModal()"
            [disabled]="!!selectedCallPassword"
            [title]="selectedCallPassword ? 'Finalize o atendimento em andamento para pausar' : 'Pausar a chamada automatica'"
            class="rounded-full px-4 flex items-center gap-1.5"
            style="height: 34px; border: 1px solid var(--brand-line); color: var(--brand-muted); font-size: 13px; font-weight: 600"
            [style.opacity]="selectedCallPassword ? '.45' : '1'"
            [style.cursor]="selectedCallPassword ? 'not-allowed' : 'pointer'"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-3.5">
              <path d="M5.75 3a.75.75 0 0 0-.75.75v12.5c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V3.75A.75.75 0 0 0 7.75 3h-2Zm6.5 0a.75.75 0 0 0-.75.75v12.5c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V3.75a.75.75 0 0 0-.75-.75h-2Z"/>
            </svg>
            Pausar
          </button>
          <div *ngIf="timerConfig.autoCallEnabled && userProfile !== 'OdontoSiM' && !isAdmin && !isPaused && placarAtalhoVc?.disponivel"
               class="relative group" data-atalho="venda-cartao" (mouseenter)="carregarPlacarAtalhoVc()">
            <button type="button" (click)="pausarParaVenda()" [disabled]="!!selectedCallPassword"
                    [attr.aria-label]="'Pausar para Venda Cartão'"
                    class="grid place-items-center rounded-full text-white"
                    style="width: 34px; height: 34px; background-color: var(--brand-primary); box-shadow: 0 4px 12px -4px rgba(43,133,38,.7)"
                    [style.opacity]="selectedCallPassword ? '.45' : '1'"
                    [style.cursor]="selectedCallPassword ? 'not-allowed' : 'pointer'">
              <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="2.5" y="5" width="19" height="14" rx="2.5"/><path d="M6 15h4"/>
                <path d="M16.6 16.8s-2.8-1.6-2.8-3.4a1.4 1.4 0 0 1 2.8-.4 1.4 1.4 0 0 1 2.8.4c0 1.8-2.8 3.4-2.8 3.4z" fill="currentColor" stroke-width="1"/>
              </svg>
            </button>
            <div class="hidden group-hover:block absolute z-30 pt-2.5" style="top: 34px; left: -14px; width: 250px">
              <div class="overflow-hidden rounded-xl" data-teste="placar-atalho"
                   style="background: var(--cartao); border: 1px solid var(--flua-borda); box-shadow: 0 18px 40px -16px rgba(11,44,69,.45)">
                <div style="padding: 12px 14px 6px">
                  <p class="modal-v2-eyebrow">Venda Cartão · hoje</p>
                  <p style="font-size: 13px; font-weight: 800; color: var(--tx); margin-top: 2px">Seu placar</p>
                </div>
                <div class="flex justify-between" style="padding: 4px 14px; font-size: 12px; color: var(--tx)"><span>Abordagens</span><b>{{ placarAtalhoVc?.abordagens ?? 0 }}</b></div>
                <div class="flex justify-between" style="padding: 4px 14px; font-size: 12px; color: var(--tx)"><span>Recusas</span><b>{{ placarAtalhoVc?.recusas ?? 0 }}</b></div>
                <div class="flex justify-between" style="padding: 4px 14px; font-size: 12px; color: var(--tx)"><span>Vendas</span><b style="color: var(--brand-primary)">{{ placarAtalhoVc?.vendas ?? 0 }}</b></div>
                <div class="flex justify-between" style="padding: 8px 14px 4px; font-size: 12px"><span style="color: var(--tx-2)">Conversão</span><b style="color: var(--tx)">{{ conversaoAtalhoVc }}%</b></div>
                <div class="overflow-hidden rounded-full" style="margin: 4px 14px 12px; height: 6px; background: var(--flua-rodape)">
                  <div class="h-full rounded-full" style="background: var(--brand-primary)" [style.width.%]="conversaoAtalhoVc"></div>
                </div>
                <div class="flex justify-between" style="padding: 9px 14px; font-size: 11px; color: var(--tx-2); border-top: 1px solid var(--flua-borda); background: var(--flua-rodape)">
                  <span>{{ selectedCallPassword ? 'Finalize o atendimento para pausar' : 'Clique para pausar e vender' }}</span><b style="color: var(--brand-primary)">→</b>
                </div>
              </div>
            </div>
          </div>
          <button
            *ngIf="timerConfig.autoCallEnabled && userProfile !== 'OdontoSiM' && !isAdmin && isPaused"
            (click)="timerRef?.resumeTimer()"
            class="rounded-full px-4 flex items-center gap-1.5 text-white"
            style="height: 34px; background-color: var(--brand-secondary); font-size: 13px; font-weight: 700"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-3.5">
              <path d="M6.3 2.84A1.5 1.5 0 0 0 4 4.11v11.78a1.5 1.5 0 0 0 2.3 1.27l9.344-5.891a1.5 1.5 0 0 0 0-2.538L6.3 2.841Z"/>
            </svg>
            Retomar atendimento
          </button>
          <!-- Estado da contagem: era a faixa propria do countdown-timer -->
          <ng-container *ngIf="timerConfig.autoCallEnabled && userProfile !== 'OdontoSiM' && !isAdmin">
            <div style="width: 1px; height: 20px; background-color: var(--brand-line)"></div>
            <span style="font-size: 12px; color: var(--brand-muted)">
              {{ isPaused
                  ? (timerRef?.pausedSeconds || 0) + 's pausado'
                  : (selectedCallPassword ? 'Em atendimento' : ((timerRef?.remaining || 0) > 0 ? 'Aguardando senhas...' : 'Chamando...')) }}
            </span>
          </ng-container>

          <span *ngIf="isPaused" class="rounded-full px-2 py-0.5"
                style="background-color: #FFF4E0; color: #8A5A0C; font-size: 11px; font-weight: 600">
            {{ currentPauseReason || 'Contagem pausada' }}
          </span>
        </div>

        <!-- Acoes -->
        <div class="flex flex-wrap items-center gap-2 ml-auto justify-end">
          <!-- Com senha chamada, esses atalhos ficam so no "Mais acoes" do card -->
          <ng-container *ngIf="!selectedCallPassword">
          <button
            (click)="abrirMeusAtendimentos()"
            class="rounded-full px-3 hover:bg-[var(--brand-tint)] hover:text-[var(--brand-ink)] dark:hover:bg-[#163247]"
            style="height: 38px; font-size: 12px; font-weight: 600; color: var(--brand-muted)"
          >
            Meus Atendimentos
          </button>
          <button
            *ngIf="isPosAtendimento || userProfile === 'OdontoSiM' || isAdmin"
            (click)="gerenateExpressPassword()"
            [disabled]="disabledButton()"
            class="rounded-full px-3 hover:bg-[var(--brand-tint)] hover:text-[var(--brand-ink)] dark:hover:bg-[#163247]"
            style="height: 38px; font-size: 12px; font-weight: 600; color: var(--brand-muted)"
            [style.opacity]="disabledButton() ? '.45' : '1'"
            [style.cursor]="disabledButton() ? 'not-allowed' : 'pointer'"
          >
            Senha Express
          </button>

          <div style="width: 1px; height: 22px; background-color: var(--brand-line)"></div>

          <button
            (click)="abrirPagamentoAvulso()"
            title="Pagamento avulso sem passar pelo atendimento"
            class="rounded-full px-3"
            style="height: 38px; background-color: var(--chip-bg); color: var(--chip-tx); font-size: 12px; font-weight: 600"
          >
            Pagamentos
          </button>
          <button
            (click)="openVerFila()"
            title="Ver fila da agenda"
            class="rounded-full px-3"
            style="height: 38px; background-color: var(--chip-bg); color: var(--chip-tx); font-size: 12px; font-weight: 600"
          >
            Fila Médico
          </button>
          <button
            (click)="abrirAgenda()"
            title="Agendas do dia e grade: agendar, encaixar, transferir"
            class="rounded-full px-3"
            style="height: 38px; background-color: var(--chip-bg); color: var(--chip-tx); font-size: 12px; font-weight: 600"
          >
            Agenda
          </button>
          <button
            (click)="abrirHistorico(false)"
            title="Agendamentos, atendimentos, adiantamentos e cupons de um paciente"
            class="rounded-full px-3"
            style="height: 38px; background-color: var(--chip-bg); color: var(--chip-tx); font-size: 12px; font-weight: 600"
          >
            Histórico
          </button>
          </ng-container>

          <!-- Chamada: acao dominante -->
          <button
            *ngIf="userProfile === 'OdontoSiM'"
            (click)="chamarProximaOdonto()"
            [disabled]="passwordsSortedForDisplay.length === 0"
            [title]="passwordsSortedForDisplay.length === 0 ? 'Nenhuma senha aguardando na fila' : passwordsSortedForDisplay.length + ' senhas aguardando na fila'"
            class="rounded-full px-4 flex items-center gap-2 text-white"
            style="height: 38px; font-size: 13px; font-weight: 700"
            [style.background-color]="passwordsSortedForDisplay.length === 0 ? '#EFE9DD' : 'var(--brand-secondary)'"
            [style.color]="passwordsSortedForDisplay.length === 0 ? 'var(--brand-muted)' : '#fff'"
            [style.cursor]="passwordsSortedForDisplay.length === 0 ? 'not-allowed' : 'pointer'"
          >
            Chamar
            <span class="rounded-full px-2" style="font-size: 11px; font-weight: 700"
                  [style.background-color]="passwordsSortedForDisplay.length === 0 ? '#E5DFD4' : 'rgba(255,255,255,.22)'">
              {{ countPasswordsWaiting() }}
            </span>
          </button>
          <button
            *ngIf="userProfile !== 'OdontoSiM' && !(timerConfig.autoCallEnabled && timerActive)"
            (click)="callNextPassword()"
            [disabled]="disabledSmartQueueButton()"
            [title]="infoTitleTooltip()"
            class="rounded-full px-4 flex items-center gap-2"
            style="height: 38px; font-size: 13px; font-weight: 700"
            [style.background-color]="disabledSmartQueueButton() ? 'var(--brand-line-soft)' : 'var(--brand-secondary)'"
            [style.color]="disabledSmartQueueButton() ? 'var(--brand-muted)' : '#fff'"
            [style.cursor]="disabledSmartQueueButton() ? 'not-allowed' : 'pointer'"
          >
            Chamar
            <span class="rounded-full px-2" style="font-size: 11px; font-weight: 700"
                  [style.background-color]="disabledSmartQueueButton() ? 'var(--flua-borda)' : 'rgba(255,255,255,.22)'">
              {{ countPasswordsWaiting() }}
            </span>
          </button>
        </div>
      </div>

      <ng-container *ngIf="selectedCallPassword">
        <div
          *ngIf="selectedCallPassword"
          class="mx-6 mb-3 bg-white dark:bg-[#10283A] shadow-sm"
          style="border-radius: 14px; border: 1px solid var(--brand-line-soft)"
        >
          <div class="flex flex-wrap items-center gap-3 px-4 py-3">
            <!-- Senha -->
            <div
              class="rounded-xl px-4 py-2.5 text-center text-white shrink-0"
              style="background-color: var(--thead); min-width: 84px; font-size: 26px; font-weight: 800; letter-spacing: .02em"
            >
              {{ selectedCallPassword.dsPassword }}
            </div>

            <!-- Identificacao -->
            <div class="flex-1 min-w-0">
              <div class="flex flex-wrap items-center gap-2">
                <span class="dark:text-white truncate" style="font-size: 21px; font-weight: 800; letter-spacing: -.01em"
                      [title]="nomeExibicao(selectedCallPassword) || 'Não identificado'">
                  {{ (nomeExibicao(selectedCallPassword) || 'Não identificado') | titlecase }}
                </span>

                <span *ngIf="selectedCallPassword.socialName?.trim()"
                      class="rounded-full px-2 py-0.5 uppercase"
                      [title]="'Nome de registro: ' + (selectedCallPassword.name | titlecase)"
                      style="background-color: #E8F0FB; color: #1D4F91; font-size: 10px; font-weight: 800">
                  Nome social
                </span>

                <span
                  *ngIf="mostraTagSimMais && temPlano(selectedCallPassword)"
                  class="flex items-center gap-1 rounded-full px-2 py-0.5 text-white uppercase"
                  style="background-color: var(--thead); font-size: 10px; font-weight: 800"
                >
                  <span class="rounded-full" style="width: 5px; height: 5px; background-color: var(--ok)"></span>
                  {{ ehDependente(selectedCallPassword) ? 'Dependente' : 'Assinante' }} {{ nomePlano }}
                </span>

                <!-- Migracao e do titular B2C: so quem tem o cadastro de assinante -->
                <button
                  *ngIf="mostraTagSimMais && temPlano(selectedCallPassword) && selectedCallPassword.subscriptionStatus && !ehDependente(selectedCallPassword)"
                  type="button" class="rounded-full px-2 py-0.5 uppercase"
                  style="background-color: #00AC70; color: #fff; font-size: 10px; font-weight: 800"
                  (click)="isMelhorarPlanoOpen = true">
                  Melhorar plano
                </button>

                <span
                  *ngIf="mostraTagSimMais && assinaturaPendente(selectedCallPassword)"
                  [title]="'Assinante ' + nomePlano + ' com pendências'"
                  class="tag-expired-sim-card rounded-full px-2 py-0.5"
                  style="font-size: 10px; font-weight: 800"
                >
                  {{ nomePlano }} assinatura pendente
                </span>

                <span
                  *ngIf="
                    selectedCallPassword.overflowed &&
                    selectedCallPassword.planDescription != queueName[filter] &&
                    queueName[filter] != 'Misto'
                  "
                  class="rounded-full px-2 py-0.5"
                  style="background-color: #FFCDAE; color: #5C2B0D; font-size: 10px; font-weight: 800"
                >
                  Atendimento de apoio
                </span>

                <span *ngIf="tagPrioridade(selectedCallPassword) as tag" class="rounded-full px-2 py-0.5 uppercase"
                      [title]="tituloPrioridade(selectedCallPassword)"
                      style="background-color: #FCEFD4; color: #8A5A0C; font-size: 10px; font-weight: 800">
                  {{ tag === 'PRIOR' ? 'Prioridade' : 'Prioridade ' + tag }}
                </span>

                <span *ngIf="isExpress" class="rounded-full px-2 py-0.5"
                      style="background-color: #FCEFD4; color: #8A5A0C; font-size: 10px; font-weight: 800">
                  Senha Express
                </span>
              </div>

              <!-- Ficha do paciente: rotulo pequeno em cima, valor embaixo -->
              <div *ngIf="!isExpress" class="ficha-paciente">
                <div class="ficha-campo">
                  <span class="ficha-rotulo">CPF</span>
                  <span class="ficha-valor" *ngIf="selectedCallPassword.cpf">
                    {{ formatCpf(selectedCallPassword.cpf) }}
                    <button type="button" class="ficha-copiar" title="Copiar CPF" aria-label="Copiar CPF"
                            (click)="copiarCampo(selectedCallPassword.cpf, 'cpf')">
                      <ng-container *ngTemplateOutlet="iconeCopiar; context: { feito: campoCopiado === 'cpf' }"></ng-container>
                    </button>
                  </span>
                  <span class="ficha-valor ficha-vazio" *ngIf="!selectedCallPassword.cpf">Não informado</span>
                </div>

                <div class="ficha-campo" *ngIf="selectedCallPassword.personId">
                  <span class="ficha-rotulo">Cód. paciente</span>
                  <span class="ficha-valor">
                    {{ selectedCallPassword.personId }}
                    <button type="button" class="ficha-copiar" title="Copiar código" aria-label="Copiar código do paciente"
                            (click)="copiarCampo('' + selectedCallPassword.personId, 'codigo')">
                      <ng-container *ngTemplateOutlet="iconeCopiar; context: { feito: campoCopiado === 'codigo' }"></ng-container>
                    </button>
                  </span>
                </div>

                <div class="ficha-campo" *ngIf="selectedCallPassword.age">
                  <span class="ficha-rotulo">Idade</span>
                  <span class="ficha-valor">{{ selectedCallPassword.age }} anos</span>
                </div>

                <div class="ficha-campo" *ngIf="dependente(selectedCallPassword.personId) !== null">
                  <span class="ficha-rotulo">Dependente</span>
                  <span class="ficha-valor">{{ dependente(selectedCallPassword.personId) ? 'Sim' : 'Não' }}</span>
                </div>

                <div class="ficha-campo ficha-texto" *ngIf="selectedCallPassword.planDescription">
                  <span class="ficha-rotulo">Convênio</span>
                  <span class="ficha-valor" [title]="selectedCallPassword.planDescription">{{ selectedCallPassword.planDescription }}</span>
                </div>

                <div class="ficha-campo ficha-texto" *ngIf="selectedCallPassword.specialty">
                  <span class="ficha-rotulo">Especialidade</span>
                  <span class="ficha-valor" [title]="selectedCallPassword.specialty">{{ selectedCallPassword.specialty }}</span>
                </div>

                <div class="ficha-campo ficha-texto" *ngIf="selectedCallPassword.hasSchedule !== 'N' || selectedCallPassword.agendaHoje">
                  <span class="ficha-rotulo">Agendamento</span>
                  <span class="ficha-valor" [title]="selectedCallPassword.agendaHoje || ''">
                    <b *ngIf="selectedCallPassword.hasSchedule !== 'N'">{{ bringScheduleTime(selectedCallPassword.hasSchedule, selectedCallPassword.scheduledTo) }}</b>
                    <span *ngIf="selectedCallPassword.hasSchedule !== 'N' && selectedCallPassword.agendaHoje" class="ficha-sep">·</span>
                    <span *ngIf="selectedCallPassword.agendaHoje" class="ficha-agenda">{{ selectedCallPassword.agendaHoje }}</span>
                  </span>
                </div>
              </div>

              <ng-template #iconeCopiar let-feito="feito">
                <svg *ngIf="!feito" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="14" height="14">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                </svg>
                <svg *ngIf="feito" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="#0E7A53" width="14" height="14">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                </svg>
              </ng-template>
            </div>

            <!-- Acoes: chamar e abrir andam juntos; descartar e destrutivo e fica
                 separado por um filete, em terciario, pra nao competir com eles -->
            <div class="flex items-center gap-2 shrink-0">
              <button
                [disabled]="isdisabled()"
                (click)="callPassword(selectedCallPassword)"
                title="Chamar a senha novamente no painel"
                class="rounded-full px-5 flex items-center justify-center gap-1.5"
                style="height: 44px; font-size: 14px; font-weight: 600"
                [ngClass]="{
                  'border border-[var(--brand-primary)] text-[var(--brand-primary)] hover:bg-[var(--brand-primary)] hover:text-white':
                    !isdisabled(),
                  'btn-disabled cursor-not-allowed': isdisabled()
                }"
              >
                <svg *ngIf="!showSpinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke-width="1.8" stroke="currentColor" class="size-4">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46" />
                </svg>
                <span *ngIf="!showSpinner">Chamar</span>
                <span *ngIf="showSpinner">
                  <svg aria-hidden="true" class="inline size-5 text-gray-200 animate-spin dark:text-gray-600 fill-[#00CD78]"
                       viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                  </svg>
                </span>
              </button>

              <button
                *ngIf="!isUnidadeAtendimento"
                (click)="finishPassword(selectedCallPassword)"
                [disabled]="!selectedCallPassword"
                class="rounded-full px-6 text-white flex items-center gap-1.5 whitespace-nowrap"
                style="height: 44px; background-color: var(--brand-secondary); font-size: 14px; font-weight: 700;
                       box-shadow: 0 2px 8px -4px rgba(0,172,112,.7)"
                onmouseover="this.style.backgroundColor='#009960'"
                onmouseout="this.style.backgroundColor='var(--brand-secondary)'"
              >
                Iniciar Atendimento
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" class="size-3.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
                </svg>
              </button>
              <button
                *ngIf="isUnidadeAtendimento"
                (click)="sendToAbrirAtendimento()"
                [disabled]="!selectedCallPassword"
                title="Abrir atendimento pelo agendamento do paciente"
                class="rounded-full px-6 text-white flex items-center gap-1.5 whitespace-nowrap"
                style="height: 44px; background-color: var(--brand-secondary); font-size: 14px; font-weight: 700;
                       box-shadow: 0 2px 8px -4px rgba(0,172,112,.7)"
                onmouseover="this.style.backgroundColor='#009960'"
                onmouseout="this.style.backgroundColor='var(--brand-secondary)'"
              >
                Abrir Atendimento
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" class="size-3.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
                </svg>
              </button>

              <div style="width: 1px; height: 22px; background-color: var(--brand-line-soft)"></div>

              <button
                *ngIf="selectedCallPassword"
                (click)="descartarExpress()"
                title="Descartar senha"
                class="rounded-lg flex items-center justify-center gap-1.5"
                style="height: 42px; padding: 0 12px; color: var(--brand-muted); font-size: 13px; font-weight: 600"
                onmouseover="this.style.backgroundColor='#FDECF1';this.style.color='#B4003C'"
                onmouseout="this.style.backgroundColor='transparent';this.style.color='var(--brand-muted)'"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="size-4">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"/>
                </svg>
                Descartar
              </button>
            </div>
          </div>

          <!-- Mais acoes: seguem disponiveis com a senha ja chamada no guiche -->
          <div
            class="flex flex-wrap items-center gap-2 px-4 py-2"
            style="background-color: var(--brand-surface); border-top: 1px solid #EFE9DD; border-radius: 0 0 14px 14px"
          >
            <span class="uppercase" style="font-size: 11px; font-weight: 800; color: var(--brand-muted); letter-spacing: .06em">Mais ações</span>
            <button
              (click)="abrirMeusAtendimentos()"
              class="rounded-full px-3 hover:bg-[var(--brand-tint-2)]"
              style="height: 34px; background-color: var(--chip-bg); color: var(--chip-tx); font-size: 13px; font-weight: 600"
            >
              Meus Atendimentos
            </button>
            <button
              (click)="abrirPagamentoAvulso(true)"
              title="Pagamento avulso sem passar pelo atendimento"
              class="rounded-full px-3 hover:bg-[var(--brand-tint-2)]"
              style="height: 34px; background-color: var(--chip-bg); color: var(--chip-tx); font-size: 13px; font-weight: 600"
            >
              Pagamentos
            </button>
            <button
              (click)="openVerFila()"
              title="Ver fila da agenda"
              class="rounded-full px-3 hover:bg-[var(--brand-tint-2)]"
              style="height: 34px; background-color: var(--chip-bg); color: var(--chip-tx); font-size: 13px; font-weight: 600"
            >
              Fila Médico
            </button>
            <button
              (click)="abrirAgenda()"
              title="Agendas do dia e grade: agendar, encaixar, transferir"
              class="rounded-full px-3 hover:bg-[var(--brand-tint-2)]"
              style="height: 34px; background-color: var(--chip-bg); color: var(--chip-tx); font-size: 13px; font-weight: 600"
            >
              Agenda
            </button>
            <button
              (click)="abrirHistorico(true)"
              title="Histórico deste paciente"
              class="rounded-full px-3 hover:bg-[var(--brand-tint-2)]"
              style="height: 34px; background-color: var(--chip-bg); color: var(--chip-tx); font-size: 13px; font-weight: 600"
            >
              Histórico
            </button>
            <button
              *ngIf="allowsExpress"
              (click)="gerenateExpressPassword()"
              [disabled]="disabledButton()"
              class="rounded-full px-3 hover:bg-[var(--brand-tint-2)]"
              style="height: 34px; background-color: var(--chip-bg); color: var(--chip-tx); font-size: 13px; font-weight: 600"
              [style.opacity]="disabledButton() ? '.45' : '1'"
              [style.cursor]="disabledButton() ? 'not-allowed' : 'pointer'"
            >
              Senha Express
            </button>
          </div>
        </div>

        <!-- Script de atendimento encantador -->
        <div
          *ngIf="selectedCallPassword && !isExpress"
          class="mx-6 mb-2 rounded-lg border-l-4 border-[var(--brand-primary)] bg-[var(--brand-tint)] dark:bg-[#163247] px-4 py-2.5 text-sm dark:text-white"
        >
          <div class="flex flex-wrap items-center gap-x-6 gap-y-1">
            <span class="font-semibold text-[var(--brand-primary)]">
              {{ getGreeting() }}, {{ getFirstName(nomeExibicao(selectedCallPassword)) }}! Seja muito bem-vindo(a) à {{ nomeMarca }}.
            </span>
            <span
              *ngIf="getWaitMinutes(selectedCallPassword) >= 15"
              class="flex items-center gap-1 text-orange-600 dark:text-orange-400"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3.5 shrink-0">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              <strong class="mx-1">{{ getWaitMinutes(selectedCallPassword) }} min</strong> de espera — <em>"Obrigado pela paciência, já vou te encaminhar!"</em>
            </span>
          </div>
        </div>

      </ng-container>
    </div>

    <hr
      *ngIf="!isAdmin && !selectedCallPassword"
      class="border-b border-gray-400 temporary-border-bot-password"
    />

    <div class="flex gap-6 dark:text-white">
      <!-- <p *ngIf="!isAdmin" class="text-sm pl-4">
        Tipo de Atendimento: &nbsp;<strong>{{ queueName[filter] }}</strong>
      </p> -->
    </div>
    <!-- Fila Unificada -->
    <div class="cartao-flua mx-6 flex-1 flex flex-col min-h-0">
      <div class="flex flex-wrap items-center gap-2 px-4 pt-3 pb-3 dark:text-gray-100">
        <h4 class="font-semibold text-sm">{{ isAdmin ? 'Acompanhamento geral' : 'Fila de atendimento' }}</h4>
        <span class="rounded-full px-2 py-0.5" style="background-color: var(--chip-bg); color: var(--chip-tx); font-size: 11px; font-weight: 700">
          {{ countPasswordsNaLista() }} aguardando
        </span>

        <!-- Distribuicao de espera: mesma colecao que alimenta as linhas -->
        <div class="flex flex-wrap items-center gap-3 ml-auto" style="font-size: 11px; color: var(--brand-muted)">
          <span class="flex items-center gap-1.5" title="Senhas esperando ate 20 minutos">
            <span class="rounded-full" style="width: 7px; height: 7px; background-color: var(--ok)"></span>
            até 20 min: <strong>{{ contarPorFaixaEspera('green') }}</strong>
          </span>
          <span class="flex items-center gap-1.5" title="Senhas esperando entre 20 e 30 minutos">
            <span class="rounded-full" style="width: 7px; height: 7px; background-color: #FF7F30"></span>
            20 a 30 min: <strong>{{ contarPorFaixaEspera('yellow') }}</strong>
          </span>
          <span class="flex items-center gap-1.5" title="Senhas esperando acima de 30 minutos">
            <span class="rounded-full" style="width: 7px; height: 7px; background-color: #B4003C"></span>
            acima de 30 min: <strong>{{ contarPorFaixaEspera('red') }}</strong>
          </span>
        </div>
      </div>
      <!-- Aguardando senha -->
      <div
        *ngIf="passwords.length === 0 && !selectedCallPassword && !isAdmin"
        class="flex-1 flex flex-col items-center justify-center text-center gap-1 py-16 px-4"
      >
        <ng-container *ngIf="!erroCarregarFila; else falhaFila">
          <p style="font-size: 15px; font-weight: 700; color: var(--tx-2)" class="dark:text-gray-200">Nenhum paciente na fila</p>
          <p style="font-size: 12px; color: var(--tx-2)">As novas senhas aparecem aqui assim que forem retiradas.</p>
        </ng-container>
        <ng-template #falhaFila>
          <p style="font-size: 15px; font-weight: 700; color: var(--tx-2)" class="dark:text-gray-200">Não foi possível carregar a fila</p>
          <p style="font-size: 12px; color: var(--tx-2)">A conexão com o servidor falhou. As senhas continuam na fila.</p>
          <button type="button" (click)="getPasswords()" class="chip-v2 ativo mt-3" style="height: 36px; padding: 0 16px">
            Tentar de novo
          </button>
        </ng-template>
      </div>

      <!-- min-w-0 no container do scroll: sem isso o grid estoura o card -->
      <div class="overflow-y-auto flex-1 min-h-0 min-w-0" *ngIf="passwords.length > 0 || isAdmin">

        <!-- Cabecalho de colunas -->
        <div
          class="grid items-center sticky top-0 text-white uppercase"
          style="background-color: var(--thead); font-size: 11px; font-weight: 700; letter-spacing: .04em; z-index: 10"
          [style.grid-template-columns]="gridColunasFila"
        >
          <div class="py-1.5 px-1 text-center" title="Peso que define a ordem da fila">Peso</div>
          <div class="py-1.5 px-2 text-center">Senha</div>
          <div class="py-1.5 px-2">Paciente</div>
          <div class="py-1.5 px-3">Espera</div>
          <div class="py-1.5 px-3 text-center" *ngIf="!isSuperClinica">Quest. Saúde</div>
          <div class="py-1.5 px-3 text-right">Guichê</div>
        </div>

        <!-- Linhas -->
        <div
          *ngFor="let password of passwordsSortedForDisplay; trackBy: trackByPasswordId"
          class="grid items-center cursor-pointer linha-fila dark:text-white"
          style="border-bottom: 1px solid #EFE9DD; font-size: 13px"
          [style.grid-template-columns]="gridColunasFila"
          [ngClass]="{
            'bg-gray-200 dark:bg-black': isRowSelected(password),
            'bg-red-50 dark:bg-red-950/40': estourou(password) && !isRowSelected(password)
          }"
          [title]="shortName(nomeExibicao(password)) | titlecase"
          (click)="onRowClick($event, password)"
        >
          <div class="py-2 px-1 text-center cursor-help"
               title="Passe o mouse para ver a composição do peso"
               (mouseenter)="showDashScoreTooltip($event, password)"
               (mouseleave)="hideDashScoreTooltip()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                 class="w-4 h-4 mx-auto" style="color: var(--tx-3)">
              <path fill-rule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clip-rule="evenodd"/>
            </svg>
          </div>

          <div class="py-2 px-2 text-center truncate" style="color: var(--brand-accent); font-weight: 700">
            {{ password.dsPassword }}
          </div>

          <!-- Paciente: nome e tags em cima, idade/tipo/agenda embaixo -->
          <div class="py-2 px-2 min-w-0">
            <div class="flex items-center gap-1.5 min-w-0">
              <span *ngIf="tagPrioridade(password) as tag" class="shrink-0 rounded px-1 py-0.5"
                    [title]="tituloPrioridade(password)"
                    style="background-color: #FCEFD4; color: #8A5A0C; font-size: 9px; font-weight: 800">{{ tag }}</span>
              <span class="truncate" style="font-weight: 600">{{ shortName(nomeExibicao(password)) | titlecase }}</span>
              <span *ngIf="password.socialName?.trim()"
                    [title]="'Nome social. Registro: ' + (password.name | titlecase)"
                    class="shrink-0 rounded-full px-1.5"
                    style="background-color: #E8F0FB; color: #1D4F91; font-size: 9px; font-weight: 800; line-height: 15px">Social</span>
              <span *ngIf="mostraTagSimMais && temPlano(password)"
                    [title]="(ehDependente(password) ? 'Dependente de plano ' : 'Assinante ') + nomePlano"
                    class="shrink-0 rounded-full px-1.5 text-white"
                    style="background-color: var(--thead); font-size: 9px; font-weight: 800; line-height: 15px">{{ nomePlano }}</span>
              <span *ngIf="isAdmin && ehDependente(password)"
                    [title]="'Dependente: o cadastro de assinante ' + nomePlano + ' fica com o titular'"
                    class="shrink-0 rounded-full px-1.5"
                    style="background-color: #E8F0FB; color: #1D4F91; font-size: 9px; font-weight: 800; line-height: 15px">Dependente</span>
              <span *ngIf="mostraTagSimMais && assinaturaPendente(password)"
                    [title]="'Assinante ' + nomePlano + ' com pendências'"
                    class="shrink-0 rounded-full px-1.5"
                    style="background-color: #FBA4C1; color: #51011C; font-size: 9px; font-weight: 800; line-height: 15px">{{ nomePlano }} pendente</span>
            </div>
            <div class="truncate sub-paciente" [title]="subtituloPaciente(password)">{{ subtituloPaciente(password) }}</div>
          </div>

          <div class="py-2 px-3 min-w-0 flex items-center gap-2">
            <span
              class="rounded-full shrink-0"
              style="width: 7px; height: 7px"
              [ngClass]="{
                'bg-[var(--ok)]': faixaEspera(password) === 'green',
                'bg-[#FF7F30]': faixaEspera(password) === 'yellow',
                'bg-[#B4003C] dark:bg-[#F00050]': faixaEspera(password) === 'red'
              }"
              [title]="faixaEspera(password) === 'green' ? 'Até 20 minutos de espera'
                     : faixaEspera(password) === 'yellow' ? 'Entre 20 e 30 minutos de espera'
                     : 'Acima de 30 minutos de espera'"
            ></span>
            <span class="truncate">{{ elapsedTimes[password.id] }}</span>
          </div>

          <div class="py-2 px-3 text-center truncate" *ngIf="!isSuperClinica">
            <span *ngIf="hraMap[password.personId]?.isAnswered; else hraNaoRespondido"
                  style="color: #0E7A53; font-weight: 600">Respondido</span>
            <ng-template #hraNaoRespondido>
              <span style="color: #B4003C; font-weight: 600">Não respondido</span>
            </ng-template>
          </div>

          <div class="py-2 px-3 text-right min-w-0" style="font-size: 11px; color: var(--brand-muted)">
            <ng-container *ngIf="password.reservadaPor; else semReserva">
              <span class="truncate block">
                {{ password.reservaModo === 'G' ? 'Priorizada (qualquer guichê)' : ((password.reservadaLocal || password.reservadaPor) + ' já pegou') }}
              </span>
            </ng-container>
            <ng-template #semReserva>
              <ng-container *ngIf="isResultado(password) && !isAdmin; else guicheCell">
                <button [disabled]="pincandoResultadoId === password.id"
                        (click)="$event.stopPropagation(); pincarResultado(password)"
                        class="px-3 py-1 rounded-md text-white"
                        style="background: var(--brand-secondary); font-size: 11px; font-weight: 600">
                  {{ pincandoResultadoId === password.id ? 'Puxando...' : 'Puxar' }}
                </button>
              </ng-container>
              <ng-template #guicheCell>
                <span class="truncate block">{{ password.calledMachine }}</span>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Resumo do supervisor, abaixo da lista (spec do redesign, parte 4 item 5) -->
      <div *ngIf="isAdmin" class="resumo-sup mx-6 mt-3 mb-4">
        <div class="resumo-card">
          <div class="flex items-center justify-between mb-2">
            <p class="resumo-titulo">Por grupo</p>
            <div class="resumo-toggle">
              <button type="button" [class.ativo]="grupoModo === 'tipo'" (click)="grupoModo = 'tipo'">Tipo</button>
              <button type="button" [class.ativo]="grupoModo === 'medico'" (click)="grupoModo = 'medico'">Médico</button>
            </div>
          </div>
          <p *ngIf="!resumoGrupos.length" class="resumo-vazio">Sem senhas aguardando.</p>
          <div *ngIf="resumoGrupos.length" class="resumo-legenda mb-2">
            <span><i class="ponto assinante"></i>{{ nomePlano }}</span>
            <span><i class="ponto particular"></i>Particular</span>
          </div>
          <div *ngFor="let g of resumoGrupos" class="resumo-linha"
               [title]="g.nome + ': ' + g.assinante + ' ' + nomePlano + ', ' + g.particular + ' particular'">
            <span class="resumo-nome">{{ g.nome }}</span>
            <span class="resumo-barra">
              <span class="resumo-barra-fill" [style.width.%]="percentualGrupo(g.total)">
                <i class="assinante" [style.flex-grow]="g.assinante"></i>
                <i class="particular" [style.flex-grow]="g.particular"></i>
              </span>
            </span>
            <span class="resumo-num">{{ g.total }}</span>
          </div>
        </div>

        <div class="resumo-card">
          <p class="resumo-titulo mb-2">Assinatura {{ nomePlano }}</p>
          <p *ngIf="!resumoAssinatura.total" class="resumo-vazio">Sem senhas aguardando.</p>
          <ng-container *ngIf="resumoAssinatura.total">
            <div class="flex items-baseline gap-2">
              <span class="resumo-destaque">{{ resumoAssinatura.assinantes }}</span>
              <span class="resumo-texto">
                de {{ resumoAssinatura.total }} na fila {{ resumoAssinatura.assinantes === 1 ? 'é assinante' : 'são assinantes' }}
              </span>
              <span class="resumo-pct">{{ resumoAssinatura.pct }}%</span>
            </div>
            <div class="resumo-progresso"><span [style.width.%]="resumoAssinatura.pct"></span></div>
            <div class="resumo-legenda">
              <span><i class="ponto assinante"></i>{{ resumoAssinatura.assinantes }} assinante(s)</span>
              <span><i class="ponto elegivel"></i>{{ resumoAssinatura.elegiveis }} particular(es) sem plano</span>
              <span *ngIf="resumoAssinatura.pendentes"><i class="ponto pendente"></i>{{ resumoAssinatura.pendentes }} com assinatura pendente</span>
            </div>
            <p class="resumo-rodape">
              {{ resumoAssinatura.elegiveis }} {{ resumoAssinatura.elegiveis === 1 ? 'particular elegível' : 'particulares elegíveis' }} à oferta no pagamento.
            </p>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</body>

<!-- Modal Priorizar Senha -->
<div *ngIf="showPriorizarModal"
     class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
  <div class="bg-white dark:bg-[#10283A] rounded-xl shadow-xl w-[460px] max-w-[92vw] max-h-[80vh] overflow-hidden flex flex-col"
       (click)="$event.stopPropagation()">
    <div class="px-5 py-3 flex items-center justify-between" style="background: var(--brand-primary)">
      <span class="text-white font-semibold">Priorizar senha {{ priorizarSenha?.dsPassword }}</span>
      <button class="text-white" (click)="fecharPriorizar()">X</button>
    </div>
    <div class="p-4 overflow-y-auto">
      <button [disabled]="priorizando"
              (click)="confirmarPriorizar('G', '')"
              class="w-full mb-3 px-4 py-2 rounded-lg text-white font-semibold"
              style="background: var(--brand-secondary)">
        Qualquer guiche (proximo livre)
      </button>
      <p class="text-xs text-gray-500 dark:text-gray-300 mb-2">Ou direcionar a um operador:</p>
      <p *ngIf="isLoadingOperadores" class="text-sm text-gray-400">Carregando operadores...</p>
      <p *ngIf="!isLoadingOperadores && operadores.length === 0" class="text-sm text-gray-400">Nenhum operador logado.</p>
      <div class="grid gap-1">
        <button *ngFor="let o of operadores"
                [disabled]="priorizando"
                (click)="confirmarPriorizar('P', o.username)"
                class="text-left px-3 py-2 rounded-md border text-sm hover:bg-purple-50 dark:hover:bg-zinc-700 flex items-center justify-between">
          <span>{{ o.username }}</span>
          <span class="text-xs text-gray-400">{{ o.machine }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Fila Médico da Agenda -->
<div *ngIf="isVerFilaModalOpen" class="modal-v2-fundo z-[10050]">
  <div role="dialog" aria-modal="true" aria-labelledby="tituloFilaMedico"
       class="modal-v2" style="max-width: 760px" (click)="$event.stopPropagation()">

    <div class="modal-v2-topo">
      <div class="flex-1 min-w-0">
        <p class="modal-v2-eyebrow">Fila médico</p>
        <h3 id="tituloFilaMedico" class="modal-v2-titulo">Fila da agenda</h3>
        <p class="modal-v2-sub">Quem está aguardando o médico e a ordem de atendimento.</p>
      </div>
      <button type="button" (click)="closeVerFila()" title="Fechar" class="modal-v2-fechar">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <div class="flex items-center gap-2 px-7 pb-4 flex-wrap" style="flex-shrink: 0">

      <!-- Overlay fecha dropdown ao clicar fora -->
      <div *ngIf="verFilaDropdownOpen" class="fixed inset-0 z-[10055]" (click)="verFilaDropdownOpen = false; $event.stopPropagation()"></div>

      <div class="relative flex-1 min-w-48" style="z-index: 10056">
        <button type="button"
                class="campo-busca w-full flex items-center justify-between gap-2 text-left"
                style="padding: 0 12px 0 14px"
                (click)="verFilaDropdownOpen = !verFilaDropdownOpen; $event.stopPropagation()">
          <span class="flex items-center gap-2 min-w-0 flex-1">
            <ng-container *ngIf="verFilaSelectedAgendaItem; else dropdownPlaceholder">
              <span class="w-2 h-2 rounded-full flex-shrink-0"
                    [style.background]="verFilaSelectedAgendaItem!.isOnline === 1 ? 'var(--ok)' : '#B4003C'"></span>
              <span class="truncate" style="font-weight: 600">{{ verFilaSelectedAgendaItem!.nmMedico || verFilaSelectedAgendaItem!.dsAgenda }}</span>
              <span *ngIf="detalheAgenda(verFilaSelectedAgendaItem!) as det" class="truncate" style="font-size: 12px; color: var(--tx-3)">{{ det }}</span>
              <span style="color: var(--tx-2)">· {{ verFilaSelectedAgendaItem!.qtAgendados }}</span>
            </ng-container>
            <ng-template #dropdownPlaceholder>
              <span style="color: var(--tx-3)">{{ verFilaLoading && !verFilaSelectedAgenda ? 'Carregando...' : 'Selecione uma agenda' }}</span>
            </ng-template>
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
               class="w-4 h-4 flex-shrink-0 transition-transform" style="color: var(--tx-2)" [class.rotate-180]="verFilaDropdownOpen">
            <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
          </svg>
        </button>

        <div *ngIf="verFilaDropdownOpen"
             class="absolute top-full left-0 right-0 mt-1 overflow-y-auto max-h-60 py-1 bg-white dark:bg-[#10283A]"
             style="border: 1px solid var(--flua-borda); border-radius: 12px; box-shadow: 0 12px 30px -12px rgba(16,24,32,.35)">
          <div *ngIf="verFilaAgendas.length === 0" class="px-3 py-2" style="font-size: 13px; color: var(--tx-2)">
            Nenhuma agenda encontrada.
          </div>
          <div *ngFor="let a of verFilaAgendas"
               class="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-[#F9F5EC] dark:hover:bg-[#163247] dark:text-gray-200"
               style="font-size: 13px; color: var(--tx)"
               [style.background]="verFilaSelectedAgenda === a.cdAgenda ? 'var(--brand-tint)' : null"
               (click)="selectVerFilaAgenda(a.cdAgenda); $event.stopPropagation()">
            <span class="w-2 h-2 rounded-full flex-shrink-0"
                  [style.background]="a.isOnline === 1 ? 'var(--ok)' : '#B4003C'"></span>
            <span class="truncate flex-1">{{ a.nmMedico || a.dsAgenda }}<span *ngIf="detalheAgenda(a) as det" style="font-size: 12px; color: var(--tx-3)"> · {{ det }}</span></span>
            <span style="color: var(--tx-2)">{{ a.qtAgendados }}</span>
          </div>
        </div>
      </div>

      <button *ngIf="verFilaSelectedAgenda" type="button" (click)="toggleSomenteAguardando()"
              class="chip-v2" [class.ativo]="verFilaSomenteAguardando" style="height: 44px; padding: 0 16px">
        Somente aguardando
      </button>
      <span *ngIf="verFilaTempoMedio && verFilaSelectedAgenda"
            class="inline-flex items-center rounded-full whitespace-nowrap"
            style="height: 44px; padding: 0 16px; font-size: 12px; color: var(--tx-2); background: var(--flua-rodape); border: 1px solid #EFE9DD"
            title="Tempo médio por paciente nesta agenda">
        <strong style="color: var(--brand-accent); font-size: 14px; margin-right: 4px">{{ verFilaTempoMedio }}</strong> min/paciente
      </span>
    </div>

    <div class="flex-1 overflow-y-auto px-7 pb-7" style="min-height: 0">

      <div *ngIf="verFilaLoading" class="flex justify-center py-10">
        <div class="h-8 w-8 animate-spin rounded-full border-b-2" style="border-color: var(--brand-primary)"></div>
      </div>

      <div *ngIf="!verFilaLoading && !verFilaSelectedAgenda"
           class="text-center rounded-xl py-10" style="border: 1px dashed var(--flua-borda); font-size: 13px; color: var(--tx-2)">
        Selecione uma agenda acima.
      </div>

      <div *ngIf="!verFilaLoading && verFilaSelectedAgenda && verFilaItemsFiltrados.length === 0"
           class="text-center rounded-xl py-10" style="border: 1px dashed var(--flua-borda); font-size: 13px; color: var(--tx-2)">
        Nenhum paciente {{ verFilaSomenteAguardando ? 'aguardando' : 'na fila' }} no momento.
      </div>

      <table *ngIf="!verFilaLoading && verFilaSelectedAgenda && verFilaItemsFiltrados.length > 0" class="tabela-v2">
        <thead>
          <tr>
            <th style="width: 44px; text-align: center">#</th>
            <th>Paciente</th>
            <th style="text-align: center">Tipo</th>
            <th style="text-align: center">Agenda</th>
            <th style="text-align: center">Entrada</th>
            <th style="text-align: center">Status</th>
            <th *ngIf="verFilaTempoMedio" style="text-align: center">Espera est.</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of verFilaItemsFiltrados">
            <td style="text-align: center; font-weight: 700; color: var(--brand-accent)">{{ p.posicao ?? '—' }}</td>
            <td>
              <div class="flex items-center gap-1.5 min-w-0">
                <span *ngIf="p.isPrioridade" class="rounded whitespace-nowrap"
                      style="padding: 2px 5px; font-size: 8px; font-weight: 800; color: #8A5A0C; background: #FCEFD4">PRIOR</span>
                <span class="truncate" style="font-weight: 700">{{ p.nmPaciente || '—' }}</span>
              </div>
              <p *ngIf="p.idade !== null" class="sub-paciente">{{ p.idade }} anos</p>
            </td>
            <td style="text-align: center">
              <span class="inline-block rounded-full whitespace-nowrap"
                    style="padding: 3px 9px; font-size: 11px; font-weight: 700"
                    [style.background]="p.tpAgenda.toUpperCase() === 'EXAME' ? '#E8F0FB' : 'var(--brand-tint)'"
                    [style.color]="p.tpAgenda.toUpperCase() === 'EXAME' ? '#1D4F91' : 'var(--brand-primary)'">
                {{ p.tpAgenda === 'EXAME' ? 'Exame' : 'Consulta' }}
              </span>
            </td>
            <td style="text-align: center; color: var(--tx-2)">{{ p.hrAgenda || '—' }}</td>
            <td style="text-align: center; color: var(--tx-2)">{{ p.hrEntrada || '—' }}</td>
            <td style="text-align: center">
              <span class="inline-flex items-center gap-1.5 whitespace-nowrap" style="font-size: 12px; font-weight: 600"
                    [style.color]="p.situacao === 'CONSULTADO' ? '#0E7A53' : p.situacao === 'AGUARDANDO' ? '#8A5A0C' : '#5B6B78'">
                <span class="w-1.5 h-1.5 rounded-full"
                      [style.background]="p.situacao === 'CONSULTADO' ? 'var(--brand-secondary)' : p.situacao === 'AGUARDANDO' ? '#FF7F30' : '#9AA6AF'"></span>
                {{ p.situacao === 'CONSULTADO' ? 'Consultado' : p.situacao === 'AGUARDANDO' ? 'Aguardando' : 'Agendado' }}
              </span>
              <span *ngIf="p.isEncaixe" class="block" style="font-size: 10px; font-weight: 600; color: var(--brand-primary)">encaixe</span>
            </td>
            <td *ngIf="verFilaTempoMedio" style="text-align: center; font-weight: 700; color: var(--brand-accent)">
              {{ verFilaEsperaEst(p.posicao) }}
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="!verFilaLoading && verFilaSelectedAgenda && verFilaItems.length > 0"
           class="mt-3 px-4 py-2.5 rounded-xl flex gap-5 flex-wrap"
           style="font-size: 12px; color: var(--tx-2); background: var(--flua-rodape); border: 1px solid #EFE9DD">
        <span><strong style="color: #0E7A53">{{ verFilaCountByStatus('CONSULTADO') }}</strong> consultados</span>
        <span><strong style="color: #8A5A0C">{{ verFilaCountByStatus('AGUARDANDO') }}</strong> aguardando</span>
        <span><strong style="color: var(--brand-accent)">{{ verFilaCountByStatus('AGENDADO') }}</strong> agendados (não chegaram)</span>
      </div>
    </div>
  </div>
</div>

<!-- Menu -->
<div
  *ngIf="manualPasswordSelected && showMenu"
  [ngStyle]="{ top: menuPosition.top, left: menuPosition.left }"
  class="fixed bg-white border border-gray-300 dark:bg-zinc-600 dark:text-white shadow-lg rounded-lg p-2 z-50 w-40"
>
  <div class="mb-1">
    <p class="text-xs">Opções para senha:</p>
    <p class="font-semibold text-xs">{{ manualPasswordSelected.dsPassword }}</p>
  </div>
  <div *ngIf="!cantCall(manualPasswordSelected)" class="grid gap-y-1">
    <button
      *ngIf="podeChamarManual(manualPasswordSelected)"
      (click)="selectPassword(manualPasswordSelected)"
      title="botão usado para chamada manual"
      class="block text-xs text-purple-800 dark:text-white dark:hover:bg-zinc-900 font-semibold w-full text-left px-2 py-1 border-b-purple-800 hover:bg-purple-800 hover:text-white hover:rounded-md"
    >
      Chamar
    </button>
    <hr class="border-b border-gray-200" />
    <button
      *ngIf="podePriorizarAgora"
      (click)="abrirPriorizar(manualPasswordSelected)"
      class="block text-xs text-purple-800 dark:text-white dark:hover:bg-zinc-900 font-semibold w-full text-left px-2 py-1 hover:bg-purple-800 hover:text-white hover:rounded-md"
    >
      Priorizar
    </button>
    <button
      (click)="discardPassword()"
      title="botao usado para finalizar uma senha"
      class="block text-xs text-purple-800 dark:text-white dark:hover:bg-zinc-900 font-semibold w-full text-left px-2 py-1 border-b-purple-800 hover:bg-purple-800 hover:text-white hover:rounded-md"
    >
      Descartar senha
    </button>
  </div>
  <div *ngIf="cantCall(manualPasswordSelected) && !isAdmin" class="grid gap-y-1">
    <p class="text-xs text-white px-2 py-1 bg-slate-400 rounded-md">
      Senha chamada por outro guichê.
    </p>
  </div>
  <div *ngIf="cantCall(manualPasswordSelected) && isAdmin" class="grid gap-y-1">
    <p class="text-xs text-slate-500 px-2 py-1 mb-1">Chamada por outro guichê.</p>
    <button
      (click)="discardPassword()"
      class="block text-xs text-red-600 font-semibold w-full text-left px-2 py-1 hover:bg-red-600 hover:text-white hover:rounded-md"
    >
      Descartar senha
    </button>
  </div>
</div>

<!-- TOAST -->
<div
  *ngIf="selectedCallPassword && openToast"
  id="toast-default"
  class="fixed bottom-5 right-5 flex items-center w-full max-w-lg p-4 text-white bg-white rounded-lg shadow"
  role="alert"
>
  <div
    class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-white bg-red-500 dark:text-white dark:bg-zinc-600 rounded-lg"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="size-5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
      />
    </svg>

    <span class="sr-only">Fire icon</span>
  </div>
  <div class="ms-3 text-sm font-normal flex gap-1">
    <p class="text-black">A senha:</p>
    <p class="text-black font-semibold">
      {{ selectedCallPassword.dsPassword }}
    </p>
    <p *ngIf="!isExpress" class="text-black">{{ toasterText }}</p>
    <p *ngIf="isExpress" class="text-black">está sendo chamada.</p>
  </div>
  <button
    type="button"
    (click)="closeToast()"
    class="ms-auto -mx-1.5 -my-1.5 bg-white text-black rounded-lg p-1.5 hover:bg-gray- inline-flex items-center justify-center h-8 w-8"
    data-dismiss-target="#toast-default"
    aria-label="Close"
  >
    <span class="sr-only">Close</span>
    <svg
      class="w-3 h-3"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
      />
    </svg>
  </button>
</div>

<!-- Express Password Modal -->
<div *ngIf="isExpressMotivModalOpen"
     class="fixed inset-0 z-[200] flex items-center justify-center"
     style="background: rgba(16,24,32,.72); backdrop-filter: blur(6px)">
  <div role="dialog" aria-modal="true" aria-labelledby="tituloExpress"
       class="bg-white dark:bg-[#10283A] flex flex-col w-[92vw]"
       style="max-width: 440px; border-radius: 18px; box-shadow: 0 24px 60px -20px rgba(16,24,32,.5)"
       (click)="$event.stopPropagation()">

    <div class="px-7 pt-6 pb-4">
      <p class="uppercase" style="font-size: 9px; font-weight: 800; letter-spacing: .12em; color: var(--brand-primary)">
        Senha Express
      </p>
      <h3 id="tituloExpress" class="dark:text-white" style="font-size: 18px; font-weight: 700; margin-top: 2px">
        Retirar senha
      </h3>
      <p style="font-size: 12px; color: var(--tx-2); margin-top: 4px">
        A senha é gerada no seu guichê e o atendimento abre direto, sem passar pela fila.
      </p>
    </div>

    <div class="px-7 pb-5 flex flex-col gap-4">
      <div role="radiogroup" aria-label="Motivo" class="flex flex-col gap-2">
        <span style="font-size: 12px; font-weight: 600; color: var(--tx-2)" class="dark:text-gray-300">Motivo</span>
        <button *ngFor="let m of ['Retirada de Senha Manual']"
                type="button" role="radio"
                [attr.aria-checked]="expressMotivo === m"
                (click)="expressMotivo = m"
                class="motivo-pausa flex items-center gap-2 text-left px-3"
                [class.selecionado]="expressMotivo === m">
          <span class="radio-motivo shrink-0" [class.marcado]="expressMotivo === m"></span>
          <span class="flex-1 py-2 dark:text-gray-200" style="font-size: 14px">{{ m }}</span>
        </button>
      </div>

      <div *ngIf="expressMotivo" class="flex flex-col gap-2">
        <label for="expressCpf" style="font-size: 12px; font-weight: 600; color: var(--tx-2)" class="dark:text-gray-300">
          CPF do paciente
        </label>
        <input id="expressCpf"
               type="text"
               inputmode="numeric"
               [(ngModel)]="expressCpf"
               (keyup.enter)="confirmExpressPassword(true)"
               maxlength="14"
               placeholder="000.000.000-00"
               class="campo-busca"
               style="padding: 0 14px"
               autofocus />
      </div>
    </div>

    <div class="flex items-center gap-2 px-7 py-4"
         style="border-top: 1px solid #EFE9DD; background-color: var(--flua-rodape); border-radius: 0 0 18px 18px">
      <button type="button" (click)="closeModal('express')"
              class="ml-auto px-6 bg-white dark:bg-transparent"
              style="height: 44px; border-radius: 10px; border: 1px solid var(--flua-borda); font-size: 14px; font-weight: 600; color: var(--tx-2)">
        Cancelar
      </button>
      <button type="button" (click)="confirmExpressPassword(true)"
              [disabled]="!expressMotivo.trim() || !expressCpf.trim()"
              class="px-6"
              style="height: 44px; border-radius: 10px; font-size: 14px; font-weight: 700"
              [style.background-color]="(!expressMotivo.trim() || !expressCpf.trim()) ? '#E5DFD4' : 'var(--brand-secondary)'"
              [style.color]="(!expressMotivo.trim() || !expressCpf.trim()) ? '#8796A1' : '#fff'"
              [style.cursor]="(!expressMotivo.trim() || !expressCpf.trim()) ? 'not-allowed' : 'pointer'">
        Abrir atendimento
      </button>
    </div>
  </div>
</div>

<app-modal *ngIf="isMelhorarPlanoOpen && selectedCallPassword" [title]="'Melhorar plano'" (onClick)="isMelhorarPlanoOpen = false">
  <app-melhorar-plano-sim [clinicId]="unitCode" [personId]="selectedCallPassword.personId" [cpf]="selectedCallPassword.cpf ?? ''"
                          [guiche]="guicheAtual" [abrirDireto]="true"></app-melhorar-plano-sim>
</app-modal>

<!-- Finish Modal  -->
<app-modal
  *ngIf="isFinishModalOpen"
  (onClick)="closeModal('finish')"
  [title]="'Atendimento senha'"
>
  <form
    [formGroup]="endServiceForm"
    (ngSubmit)="submitPassword()"
    class="px-16"
  >
    <div selector="body" class="mt-4">
      <label
        for="finishPassword"
        class="block text-xs font-medium text-gray-700"
        >Selecione uma ação</label
      >
      <select
        (change)="selectFinishOption($event)"
        name="finishPassword"
        id="finishPassword"
        class="mt-1 block w-full py-1 px-3 border border-gray-300 bg-white dark:bg-zinc-600 dark:text-white dark:focus:ring-0 dark:focus:border-white rounded-md shadow-sm focus:outline-none focus:ring-purple-500 focus:border-purple-600 sm:text-sm"
      >
        <option disabled selected>Selecione uma ação</option>
        <option value="1">Paciente atendido</option>
        <option value="2">Paciente não atendido</option>
        <option value="3">Descartar senha</option>
        <option value="4">Vincular paciente a agenda</option>
      </select>
    </div>

    <div class="flex mt-6 mb-10 gap-6">
      <button
        (click)="closeModal('finish')"
        type="button"
        class="border border-purple-600 text-purple-600 px-4 py-1 rounded-lg w-full hover:bg-purple-600 hover:text-white dark:text-white dark:border-white dark:hover:bg-zinc-600 dark:hover:text-white temporary-border-1px"
      >
        Cancelar
      </button>
      <button
        [disabled]="!isFinishOptionSelected"
        type="submit"
        class="text-white px-4 py-1 rounded-lg w-full"
        [ngClass]="{
          'bg-purple-600 hover:bg-purple-500 dark:bg-purple-800 dark:hover:bg-purple-700':
            isFinishOptionSelected,
          'bg-zinc-300': !isFinishOptionSelected
        }"
      >
        Confirmar
      </button>
    </div>
  </form>
</app-modal>

<!-- Info Modal  -->
<div *ngIf="isModalOpen" class="modal-v2-fundo z-[300]">
  <div role="alertdialog" aria-modal="true" aria-labelledby="tituloAviso" aria-describedby="textoAviso"
       class="modal-v2" style="max-width: 420px" (click)="$event.stopPropagation()">
    <div class="flex items-start gap-4 px-7 pt-6 pb-5">
      <span class="grid place-items-center shrink-0 rounded-full"
            style="width: 40px; height: 40px; background: var(--brand-tint); color: var(--brand-primary)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"/>
        </svg>
      </span>
      <div class="flex-1 min-w-0">
        <h3 id="tituloAviso" class="modal-v2-titulo" style="margin-top: 0">{{ modalTitle }}</h3>
        <p id="textoAviso" style="font-size: 14px; color: var(--tx-2); margin-top: 4px" class="dark:text-gray-300">{{ modalMessage }}</p>
      </div>
    </div>
    <div class="flex justify-end px-7 py-4"
         style="border-top: 1px solid #EFE9DD; background-color: var(--flua-rodape); border-radius: 0 0 18px 18px">
      <button type="button" (click)="closeModal('info')" autofocus
              class="px-6 text-white"
              style="height: 40px; border-radius: 10px; font-size: 14px; font-weight: 700; background-color: var(--brand-primary)">
        Entendi
      </button>
    </div>
  </div>
</div>

<!-- ════════════════════════════════════════════════════════════
     MODAL — MEUS ATENDIMENTOS DO DIA
     ════════════════════════════════════════════════════════════ -->
<div *ngIf="showMeusAtendimentosModal" class="modal-v2-fundo z-50">
  <div role="dialog" aria-modal="true" aria-labelledby="tituloMeusAtendimentos"
       class="modal-v2" style="max-width: 1100px" (click)="$event.stopPropagation()">

    <div class="modal-v2-topo">
      <div class="flex-1 min-w-0">
        <p class="modal-v2-eyebrow">{{ userName }}</p>
        <h3 id="tituloMeusAtendimentos" class="modal-v2-titulo">Meus atendimentos de hoje</h3>
        <p class="modal-v2-sub">
          {{ meusAtendimentos.length }} {{ meusAtendimentos.length === 1 ? 'atendimento aberto' : 'atendimentos abertos' }} por você hoje.
        </p>
      </div>
      <button type="button" (click)="fecharMeusAtendimentosModal()" title="Fechar" class="modal-v2-fechar">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <div *ngIf="meusAtendimentos.length > 0" class="px-7 pb-4 flex flex-wrap items-center gap-2" style="flex-shrink: 0">
      <button type="button" class="chip-v2" [class.ativo]="filtroMeusAtendimentos === 'todos'"
              (click)="filtroMeusAtendimentos = 'todos'">
        Todos · {{ contarMeusAtendimentos('todos') }}
      </button>
      <button type="button" class="chip-v2" [class.ativo]="filtroMeusAtendimentos === 'provisorio'"
              (click)="filtroMeusAtendimentos = 'provisorio'">
        Provisório · {{ contarMeusAtendimentos('provisorio') }}
      </button>
      <button type="button" class="chip-v2" [class.ativo]="filtroMeusAtendimentos === 'definitivo'"
              (click)="filtroMeusAtendimentos = 'definitivo'">
        Definitivo · {{ contarMeusAtendimentos('definitivo') }}
      </button>
      <button type="button" class="chip-v2" [class.ativo]="filtroMeusAtendimentos === 'definitivo_saldo'"
              (click)="filtroMeusAtendimentos = 'definitivo_saldo'">
        Definitivo c/ saldo · {{ contarMeusAtendimentos('definitivo_saldo') }}
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-7 pb-7" style="min-height: 0">
      <div *ngIf="isLoadingMeusAtendimentos" class="flex justify-center py-16">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2" style="border-color: var(--brand-primary)"></div>
      </div>

      <div *ngIf="!isLoadingMeusAtendimentos && meusAtendimentos.length === 0"
           class="flex flex-col items-center text-center rounded-xl py-12 px-4"
           style="border: 1px dashed var(--flua-borda)">
        <p style="font-size: 14px; font-weight: 600; color: var(--tx-2)" class="dark:text-gray-200">Nenhum atendimento hoje</p>
        <p style="font-size: 12px; color: var(--tx-2); margin-top: 2px">Os atendimentos que você abrir aparecem aqui.</p>
      </div>

      <div *ngIf="!isLoadingMeusAtendimentos && meusAtendimentos.length > 0 && meusAtendimentosFiltrados.length === 0"
           class="text-center py-12" style="font-size: 13px; color: var(--tx-2)">
        Nenhum atendimento neste filtro.
      </div>

      <table *ngIf="!isLoadingMeusAtendimentos && meusAtendimentosFiltrados.length > 0" class="tabela-v2 table-fixed">
        <colgroup>
          <col style="width: 10%"/>
          <col style="width: 27%"/>
          <col style="width: 13%"/>
          <col style="width: 20%"/>
          <col style="width: 12%"/>
          <col style="width: 18%"/>
        </colgroup>
        <thead>
          <tr>
            <th>Atend.</th>
            <th>Paciente</th>
            <th>Tipo</th>
            <th>Médico</th>
            <th style="text-align: center">Conta</th>
            <th style="text-align: right">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of meusAtendimentosFiltrados">
            <td style="font-weight: 700; color: var(--brand-accent)">{{ a.nrAtendimento }}</td>
            <td>
              <p class="truncate" style="font-weight: 700">{{ a.nmPaciente }}</p>
              <p class="sub-paciente">Cód. {{ a.cdPessoaFisica }}</p>
            </td>
            <td>
              <span class="selo-classificacao" [ngClass]="(a.classificacao || 'OUTRO').toLowerCase()"
                    [title]="a.dsTipoAtendimento || ''">
                {{ a.classificacao === 'CONSULTA' ? 'Consulta' : a.classificacao === 'EXAME' ? 'Exame' : a.classificacao === 'ODONTO' ? 'Odonto' : 'Outro' }}
              </span>
            </td>
            <td class="truncate">{{ a.nmMedico }}</td>
            <td style="text-align: center">
              <span class="inline-block rounded-full whitespace-nowrap"
                    style="padding: 3px 9px; font-size: 11px; font-weight: 700"
                    [style.background]="a.statusConta?.toLowerCase()?.includes('definit') ? 'rgba(0,172,112,.10)' : a.statusConta?.toLowerCase()?.includes('provis') ? '#FCEFD4' : '#F4F1EA'"
                    [style.color]="a.statusConta?.toLowerCase()?.includes('definit') ? '#0E7A53' : a.statusConta?.toLowerCase()?.includes('provis') ? '#8A5A0C' : '#4A5D6B'">
                {{ a.statusConta || 'Sem conta' }}
              </span>
            </td>
            <td>
              <div class="flex items-center justify-end gap-1.5">
                <button type="button" (click)="verFichaMeuAtendimento(a)" title="Ver ficha (PDF)"
                        class="chip-v2">
                  Ver ficha
                </button>
                <button type="button" (click)="selecionarMeuAtendimento(a)"
                        class="chip-v2 ativo">
                  Ver contas
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- ════════════════════════════════════════════════════════════
     MODAL — DETALHES DO PACIENTE (Contas)
     ════════════════════════════════════════════════════════════ -->
<div *ngIf="showDetalhesPacienteModal" class="modal-v2-fundo z-50">
  <div role="dialog" aria-modal="true" aria-labelledby="tituloContasPaciente"
       class="modal-v2" style="max-width: 1200px; max-height: 92vh" (click)="$event.stopPropagation()">

    <div class="modal-v2-topo">
      <div class="flex-1 min-w-0">
        <p class="modal-v2-eyebrow">Contas do paciente</p>
        <h3 id="tituloContasPaciente" class="modal-v2-titulo truncate">{{ detalhesPaciente?.nmPessoaFisica }}</h3>
        <p class="modal-v2-sub">
          Cód. {{ detalhesPaciente?.cdPessoaFisica }}
          <ng-container *ngIf="detalhesPaciente?.nrCpf"> · CPF {{ formatCpf(detalhesPaciente!.nrCpf) }}</ng-container>
        </p>
      </div>
      <button type="button" (click)="fecharDetalhesPacienteModal()" title="Fechar" class="modal-v2-fechar">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <div *ngIf="pagandoConta" class="flex items-center gap-3 px-7 pb-4" style="flex-shrink: 0">
      <button type="button" (click)="voltarParaContas()" class="chip-v2 flex items-center gap-1">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="size-3.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"/>
        </svg>
        {{ contasDoHistorico ? 'Voltar ao histórico' : 'Voltar às contas' }}
      </button>
      <span style="font-size: 13px; font-weight: 700; color: var(--brand-accent)">
        Pagamento · conta #{{ pagandoConta.nrInternoConta }}
      </span>
    </div>

    <div class="flex-1 overflow-y-auto" style="min-height: 0">

      <!-- ═══════ VIEW: Lista de Contas ═══════ -->
      <ng-container *ngIf="!pagandoConta && !contasDoHistorico">

        <div *ngIf="contaAcaoSucesso" class="mx-7 mb-3 aviso-v2 flex items-center gap-2"
             [class.verde]="!contaAcaoAvisoCupom" [class.ambar]="contaAcaoAvisoCupom">
          <span class="flex-1">{{ contaAcaoSucesso }}</span>
          <button type="button" (click)="contaAcaoSucesso = ''" title="Fechar aviso" style="font-weight: 700">✕</button>
        </div>

        <div *ngIf="contasPaciente.length > 0" class="px-7 pb-4 flex flex-wrap items-center gap-2">
          <button type="button" class="chip-v2" [class.ativo]="filtroStatusConta === 'todos'"
                  (click)="filtroStatusConta = 'todos'">
            Todas · {{ contarStatus('todos') }}
          </button>
          <button type="button" class="chip-v2" [class.ativo]="filtroStatusConta === 'provisorio'"
                  (click)="filtroStatusConta = 'provisorio'">
            Provisório · {{ contarStatus('provisorio') }}
          </button>
          <button type="button" class="chip-v2" [class.ativo]="filtroStatusConta === 'definitivo'"
                  (click)="filtroStatusConta = 'definitivo'">
            Definitivo · {{ contarStatus('definitivo') }}
          </button>
          <button type="button" class="chip-v2" [class.ativo]="filtroStatusConta === 'definitivo_saldo'"
                  (click)="filtroStatusConta = 'definitivo_saldo'">
            Definitivo c/ saldo · {{ contarStatus('definitivo_saldo') }}
          </button>
        </div>

        <div *ngIf="isLoadingContas" class="flex justify-center py-10">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2" style="border-color: var(--brand-primary)"></div>
        </div>

        <div *ngIf="!isLoadingContas && contasPaciente.length === 0"
             class="mx-7 mb-7 text-center rounded-xl py-10" style="border: 1px dashed var(--flua-borda); font-size: 13px; color: var(--tx-2)">
          Nenhuma conta encontrada para este paciente.
        </div>

        <div *ngIf="!isLoadingContas && contasPaciente.length > 0" class="px-7 pb-7">
          <div class="overflow-x-auto">
            <table class="tabela-v2 tabela-contas">
              <thead>
                <tr>
                  <th>Atendimento</th>
                  <th>Data · unidade</th>
                  <th style="text-align: center">Itens</th>
                  <th style="text-align: right">Valor</th>
                  <th style="text-align: right">Pago</th>
                  <th style="text-align: right">Saldo</th>
                  <th style="text-align: center">Status</th>
                  <th>Usuário</th>
                  <th class="acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let conta of contasExibidas">
                  <td>
                    <p style="font-weight: 700; color: var(--brand-accent)">#{{ conta.nrAtendimento }}</p>
                    <p class="sub-paciente">Conta #{{ conta.nrInternoConta }}</p>
                  </td>
                  <td style="max-width: 200px">
                    <p>{{ conta.dtPeriodoInicial }}</p>
                    <p class="sub-paciente truncate" [title]="conta.estabelecimento">{{ conta.estabelecimento }}</p>
                  </td>
                  <td style="text-align: center">{{ conta.qtItens }}</td>
                  <td style="text-align: right; font-variant-numeric: tabular-nums">
                    <p style="font-weight: 700">{{ formatCurrencyDash(conta.vlConta) }}</p>
                    <p *ngIf="conta.vlDesconto > 0" class="sub-paciente" style="color: #0E7A53">- {{ formatCurrencyDash(conta.vlDesconto) }}<span *ngIf="conta.cupomAplicado"> · {{ conta.cupomAplicado }}</span></p>
                  </td>
                  <td style="text-align: right; color: var(--tx-2); font-variant-numeric: tabular-nums">{{ conta.vlPago > 0 ? formatCurrencyDash(conta.vlPago) : 'R$ 0,00' }}</td>
                  <td style="text-align: right; font-weight: 700; font-variant-numeric: tabular-nums"
                      [style.color]="(conta.vlConta - conta.vlPago) > 0 ? '#B4003C' : '#0E7A53'">
                    {{ (conta.vlConta - conta.vlPago) <= 0 ? 'Quitado' : formatCurrencyDash(conta.vlConta - conta.vlPago) }}
                  </td>
                  <td style="text-align: center">
                    <span class="inline-block rounded-full whitespace-nowrap"
                          style="padding: 3px 9px; font-size: 11px; font-weight: 700"
                          [style.background]="conta.statusConta === 'Definitivo' ? 'rgba(0,172,112,.10)' : '#FCEFD4'"
                          [style.color]="conta.statusConta === 'Definitivo' ? '#0E7A53' : '#8A5A0C'">
                      {{ conta.statusConta || 'Provisório' }}
                    </span>
                  </td>
                  <td class="truncate" style="color: var(--tx-2); max-width: 120px" [title]="conta.nmUsuario">{{ conta.nmUsuario }}</td>
                  <td class="acoes">
                    <div class="flex items-center justify-end gap-1.5">
                      <button type="button" (click)="vincularDireto(conta)" title="Vincular adiantamento" class="chip-v2">
                        Vincular
                      </button>
                      <button type="button" (click)="iniciarPagamento(conta)" title="Pagar"
                              class="rounded-full text-white whitespace-nowrap"
                              style="height: 30px; padding: 0 14px; font-size: 12px; font-weight: 700; background: var(--brand-secondary)">
                        Pagar
                      </button>
                      <!-- Ações de supervisor: o back confere o perfil de novo em cada chamada -->
                      <button *ngIf="supervisorConta" type="button" class="chip-v2"
                              style="padding: 0 10px; font-weight: 800; letter-spacing: .08em"
                              title="Ações de supervisor" (click)="abrirMenuConta($event, conta)">
                        ⋯
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="contasVisiveis < contasPaciente.length" class="pt-4 text-center">
            <button type="button" (click)="verMaisContas()" class="chip-v2">
              Ver mais {{ contasPaciente.length - contasVisiveis }} contas anteriores
            </button>
          </div>
        </div>

      </ng-container>

      <!-- ═══════ VIEW: Pagamento de Conta ═══════ -->
      <ng-container *ngIf="pagandoConta">
        <div class="px-7 pb-7 space-y-4">

          <!-- Identificação da conta (clique copia) -->
          <div class="flex flex-wrap items-center gap-2">
            <button type="button" class="chip-v2 flex items-center gap-1.5"
                    (click)="pgCopiarValor('pg-atend', pagandoConta.nrAtendimento)"
                    [title]="pgCopiadoCampo === 'pg-atend' ? 'Copiado!' : 'Clique para copiar'">
              Atendimento <strong style="color: var(--brand-accent)">#{{ pagandoConta.nrAtendimento }}</strong>
              <span *ngIf="pgCopiadoCampo === 'pg-atend'" style="color: #0E7A53">copiado</span>
            </button>
            <button type="button" class="chip-v2 flex items-center gap-1.5"
                    (click)="pgCopiarValor('pg-conta', pagandoConta.nrInternoConta)"
                    [title]="pgCopiadoCampo === 'pg-conta' ? 'Copiado!' : 'Clique para copiar'">
              Conta <strong style="color: var(--brand-accent)">#{{ pagandoConta.nrInternoConta }}</strong>
              <span *ngIf="pgCopiadoCampo === 'pg-conta'" style="color: #0E7A53">copiado</span>
            </button>
          </div>

          <div *ngIf="pgLoading" class="flex justify-center py-8">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2" style="border-color: var(--brand-primary)"></div>
          </div>

          <div *ngIf="pgErro && !pgLoading" class="aviso-v2 vermelho flex items-start gap-2 sticky top-0 z-10">
            <span class="flex-1">{{ pgErro }}</span>
            <button type="button" (click)="pgErro = ''" title="Fechar aviso" style="font-weight: 700">✕</button>
          </div>

          <!-- Conteúdo financeiro -->
          <ng-container *ngIf="pgDados && !pgLoading && !pgResultado">

            <div class="grid gap-3" style="grid-template-columns: repeat(auto-fit, minmax(200px, 1fr))">
              <div class="rounded-2xl px-4 py-3" style="border: 1px solid #EFE9DD">
                <p class="form-v2-secao">Valor da conta</p>
                <p style="font-size: 22px; font-weight: 800; color: var(--tx); font-variant-numeric: tabular-nums">{{ formatCurrencyDash(pgDados.vlTotalConta) }}</p>
                <p *ngIf="pgDados.vlDesconto > 0" style="font-size: 12px; color: #0E7A53">- {{ formatCurrencyDash(pgDados.vlDesconto) }} de desconto<span *ngIf="pgDados.cupomAplicado"> · {{ pgDados.cupomAplicado }}</span></p>
              </div>
              <div class="rounded-2xl px-4 py-3" style="border: 1px solid #EFE9DD">
                <p class="form-v2-secao">Crédito do paciente</p>
                <p style="font-size: 22px; font-weight: 800; font-variant-numeric: tabular-nums"
                   [style.color]="pgDados.vlAdiantamento > 0 ? '#0E7A53' : '#5B6B78'">
                  {{ pgDados.vlAdiantamento > 0 ? formatCurrencyDash(pgDados.vlAdiantamento) : 'Sem crédito' }}
                </p>
                <p style="font-size: 12px; color: var(--tx-2)">Adiantamentos disponíveis</p>
              </div>
              <div class="rounded-2xl px-4 py-3"
                   [style.background]="pgDados.vlAdiantamento >= pgDados.vlSaldo ? 'rgba(0,172,112,.08)' : '#F9F5EC'"
                   [style.border]="'1px solid ' + (pgDados.vlAdiantamento >= pgDados.vlSaldo ? 'rgba(0,172,112,.28)' : '#EFE9DD')">
                <p class="form-v2-secao">Falta receber</p>
                <p style="font-size: 22px; font-weight: 800; font-variant-numeric: tabular-nums"
                   [style.color]="pgDados.vlAdiantamento >= pgDados.vlSaldo ? '#0E7A53' : '#B4003C'">
                  {{ pgDados.vlAdiantamento >= pgDados.vlSaldo ? 'Quitado' : formatCurrencyDash(pgDados.vlSaldo - pgDados.vlAdiantamento) }}
                </p>
                <p style="font-size: 12px; color: var(--tx-2)">
                  {{ pgDados.vlAdiantamento >= pgDados.vlSaldo ? 'O crédito cobre a conta.' : 'Saldo da conta menos o crédito.' }}
                </p>
              </div>
            </div>

            <!-- Itens da Conta (sempre aberto, sempre editável) -->
            <div>
              <p class="form-v2-secao mb-2">Itens da conta</p>

              <div>
                <div *ngIf="pgLoadingItens" class="flex justify-center py-4">
                  <div class="animate-spin rounded-full h-5 w-5 border-b-2" style="border-color: var(--brand-primary)"></div>
                </div>

                <div *ngIf="!pgLoadingItens && pgItens.length > 0">
                  <table class="tabela-v2">
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Procedimento</th>
                        <th>Médico executor</th>
                        <th style="text-align: center">Qtd.</th>
                        <th style="text-align: right">Valor unit.</th>
                        <th style="text-align: right">Valor total</th>
                        <th *ngIf="pgEditandoItens" style="width: 40px"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of pgItens; let last = last">
                        <td class="px-3 py-2.5" style="color: var(--tx-2)">{{ item.nrSeqProcInterno }}</td>
                        <td class="px-3 py-2.5 font-medium" style="color: var(--tx)">{{ item.dsProcedimento }}</td>
                        <!-- Médico Executor -->
                        <td class="px-3 py-2.5 relative" style="color: var(--tx-2)">
                          <span *ngIf="!pgEditandoItens && !item.editandoMedico">{{ item.nomeMedico || '—' }}</span>
                          <span *ngIf="pgEditandoItens && !item.editandoMedico"
                                (click)="pgToggleEditarMedico(item)"
                                class="cursor-pointer underline decoration-dotted"
                                style="color: var(--brand-primary)" title="Clique para alterar">{{ item.nomeMedico || '—' }}</span>
                          <div *ngIf="item.editandoMedico" class="relative">
                            <input type="text" [(ngModel)]="item.medicoBusca"
                                   (input)="pgFiltrarMedicosItem(item)"
                                   (focus)="pgFiltrarMedicosItem(item)"
                                   placeholder="Buscar médico..."
                                   class="w-full text-xs px-2 py-1 rounded border"
                                   style="border-color: var(--flua-borda); outline: none"/>
                            <div *ngIf="item.showMedicoDropdown"
                                 class="absolute z-10 left-0 right-0 rounded-lg shadow-lg overflow-hidden"
                                 [style]="'background-color: white; border: 1px solid #E5DFD4; max-height: 150px; overflow-y: auto;' + (last ? 'bottom: 100%; margin-bottom: 2px' : 'top: 100%; margin-top: 4px')">
                              <div *ngFor="let m of item.medicosFiltrados"
                                   (mousedown)="pgSelecionarMedicoItem(item, m)"
                                   class="px-2 py-1.5 text-xs cursor-pointer hover:bg-gray-100"
                                   style="color: var(--tx)">
                                {{ m.nmGuerra }}<span *ngIf="m.isParceiro" class="ml-1 text-[10px]" style="color: var(--tx-2)">parceiro</span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <!-- Quantidade -->
                        <td class="px-3 py-2.5">
                          <div *ngIf="!pgEditandoItens" class="text-center font-semibold" style="color: var(--tx)">{{ item.qtProcedimento }}</div>
                          <div *ngIf="pgEditandoItens" class="flex items-center justify-center gap-1">
                            <button (click)="pgAlterarQtdItem(item, -1)" [disabled]="item.qtProcedimento <= 1"
                                    class="w-5 h-5 rounded flex items-center justify-center text-xs"
                                    [style.color]="item.qtProcedimento <= 1 ? '#E5DFD4' : '#4A5D6B'"
                                    [style.border]="'1px solid ' + (item.qtProcedimento <= 1 ? '#E5DFD4' : '#4A5D6B')"
                                    [style.cursor]="item.qtProcedimento <= 1 ? 'not-allowed' : 'pointer'"
                                    style="background: var(--cartao)">−</button>
                            <span class="w-5 text-center font-semibold text-xs" style="color: var(--tx)">{{ item.qtProcedimento }}</span>
                            <button (click)="pgAlterarQtdItem(item, 1)"
                                    class="w-5 h-5 rounded flex items-center justify-center text-xs"
                                    style="border: 1px solid #4A5D6B; color: var(--tx-2); background: var(--cartao); cursor: pointer">+</button>
                          </div>
                        </td>
                        <td class="px-3 py-2.5 text-right" style="color: var(--tx-2)">{{ formatCurrencyDash(item.vlUnitario || 0) }}</td>
                        <td class="px-3 py-2.5 text-right font-semibold" style="color: var(--tx)">{{ formatCurrencyDash((item.vlUnitario || 0) * item.qtProcedimento) }}</td>
                        <td *ngIf="pgEditandoItens" class="px-3 py-2.5 text-center">
                          <button (click)="pgRemoverItem(item)" class="p-1 rounded hover:bg-gray-100"
                                  style="color: var(--tx-2); cursor: pointer" title="Remover item">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                 stroke-width="2" stroke="currentColor" class="size-3.5">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"/>
                            </svg>
                          </button>
                        </td>
                      </tr>
                      <!-- Nova linha para adicionar procedimento -->
                      <tr *ngIf="pgAdicionandoProc" style="background-color: var(--brand-surface)">
                        <td class="px-3 py-2.5" style="color: var(--tx-2)">—</td>
                        <td class="px-3 py-2.5 relative" colspan="2">
                          <div class="relative">
                            <input type="text" [(ngModel)]="pgNovoProcBusca"
                                   (input)="pgFiltrarNovoProc()"
                                   (focus)="pgFiltrarNovoProc()"
                                   placeholder="Buscar procedimento por nome ou código..."
                                   class="w-full text-xs px-2 py-1.5 rounded border"
                                   style="border-color: var(--flua-borda); outline: none"/>
                            <div *ngIf="pgShowNovoProcDropdown"
                                 class="absolute z-10 left-0 right-0 mt-1 rounded-lg shadow-lg overflow-hidden"
                                 style="background-color: var(--cartao); border: 1px solid var(--flua-borda); max-height: 180px; overflow-y: auto">
                              <div *ngFor="let p of pgNovoProcFiltrados"
                                   (mousedown)="pgSelecionarNovoProc(p)"
                                   class="px-3 py-2 text-xs cursor-pointer hover:bg-gray-100"
                                   style="color: var(--tx)">
                                <span class="font-medium">{{ p.dsProcExame }}</span>
                                <span class="ml-1" style="color: var(--tx-2)">({{ p.cdProcedimento }})</span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="px-3 py-2.5">
                          <div class="flex items-center justify-center gap-1">
                            <button (click)="pgNovoProcQtd > 1 && (pgNovoProcQtd = pgNovoProcQtd - 1)"
                                    [disabled]="pgNovoProcQtd <= 1"
                                    class="w-5 h-5 rounded flex items-center justify-center text-xs"
                                    [style.color]="pgNovoProcQtd <= 1 ? '#E5DFD4' : '#4A5D6B'"
                                    [style.border]="'1px solid ' + (pgNovoProcQtd <= 1 ? '#E5DFD4' : '#4A5D6B')"
                                    style="background: var(--cartao)">−</button>
                            <span class="w-5 text-center font-semibold text-xs" style="color: var(--tx)">{{ pgNovoProcQtd }}</span>
                            <button (click)="pgNovoProcQtd = pgNovoProcQtd + 1"
                                    class="w-5 h-5 rounded flex items-center justify-center text-xs"
                                    style="border: 1px solid #4A5D6B; color: var(--tx-2); background: var(--cartao); cursor: pointer">+</button>
                          </div>
                        </td>
                        <td class="px-3 py-2.5 text-right" style="color: var(--tx-2)">—</td>
                        <td class="px-3 py-2.5 text-right" style="color: var(--tx-2)">—</td>
                        <td *ngIf="pgEditandoItens" class="px-3 py-2.5 text-center">
                          <div class="flex items-center justify-center gap-1">
                            <button (click)="pgConfirmarAdicionarProc()"
                                    [disabled]="!pgNovoProcSelecionado || pgIsAdicionandoProc"
                                    class="p-2 rounded-lg"
                                    [style.color]="pgNovoProcSelecionado ? '#00AC70' : '#E5DFD4'"
                                    [style.cursor]="pgNovoProcSelecionado ? 'pointer' : 'not-allowed'"
                                    [style.backgroundColor]="pgNovoProcSelecionado ? '#f0fdf4' : 'transparent'"
                                    title="Confirmar">
                              <div *ngIf="pgIsAdicionandoProc" class="animate-spin rounded-full h-5 w-5 border-b-2" style="border-color: var(--brand-primary)"></div>
                              <svg *ngIf="!pgIsAdicionandoProc" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                   stroke-width="2.5" stroke="currentColor" class="size-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
                              </svg>
                            </button>
                            <button (click)="pgCancelarAdicionarProc()" class="p-2 rounded-lg hover:bg-gray-100"
                                    style="color: var(--tx-2); cursor: pointer" title="Cancelar">
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                   stroke-width="2.5" stroke="currentColor" class="size-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div *ngIf="!pgLoadingItens && pgItens.length === 0"
                     class="text-center rounded-xl py-6" style="border: 1px dashed var(--flua-borda); font-size: 13px; color: var(--tx-2)">
                  Nenhum item encontrado na conta.
                </div>

                <div *ngIf="!pgLoadingItens && pgItens.length > 0"
                     class="flex justify-between items-center px-3 pt-3">
                  <span style="font-size: 12px; font-weight: 600; color: var(--tx-2)">
                    Total · {{ pgItens.length }} {{ pgItens.length === 1 ? 'item' : 'itens' }}
                  </span>
                  <span style="font-size: 15px; font-weight: 800; color: var(--brand-accent); font-variant-numeric: tabular-nums">{{ formatCurrencyDash(pgDados.vlTotalConta) }}</span>
                </div>
              </div>
            </div>

            <!-- Barra de ações -->
            <div class="rounded-2xl px-4 py-3 flex flex-wrap items-center gap-2"
                 style="background-color: var(--flua-rodape); border: 1px solid #EFE9DD">
              <div *ngIf="!pgContaDefinitiva" class="flex items-center gap-2 flex-wrap">
                <button type="button" (click)="pgAbrirAdicionarProc()" [disabled]="pgDados.vlDesconto > 0"
                        [title]="pgDados.vlDesconto > 0 ? 'Remova o cupom/desconto antes de adicionar procedimentos ou orçamentos' : ''"
                        class="chip-v2" [style.opacity]="pgDados.vlDesconto > 0 ? '.45' : '1'">
                  + Procedimento
                </button>
                <button type="button" (click)="pgAbrirOrcamentoModal()" [disabled]="pgDados.vlDesconto > 0"
                        [title]="pgDados.vlDesconto > 0 ? 'Remova o cupom/desconto antes de adicionar procedimentos ou orçamentos' : ''"
                        class="chip-v2" [style.opacity]="pgDados.vlDesconto > 0 ? '.45' : '1'">
                  + Orçamento
                </button>
                <button type="button" (click)="pgAbrirCupomModal()" class="chip-v2">
                  + Cupom
                </button>
              </div>
              <div class="flex items-center gap-2 flex-wrap" style="margin-left: auto">
                <button type="button" (click)="pgVerFichaPdf()" class="chip-v2">Ver ficha</button>
                <button type="button" (click)="voltarParaContas()" class="chip-v2">Pular pagamento</button>
                <span style="width: 1px; height: 24px; background: #E5DFD4"></span>
                <button type="button" (click)="pgAbrirMaquinetaModal()"
                        class="rounded-full px-4" style="height: 38px; font-size: 13px; font-weight: 700; color: var(--brand-primary); background: var(--brand-tint); border: 1px solid var(--brand-tint-2)">
                  Maquininha
                </button>
                <button *ngIf="pgHasCaixaAccess" type="button" (click)="pgShowEspecie = true"
                        class="rounded-full px-4" style="height: 38px; font-size: 13px; font-weight: 700; color: var(--brand-primary); background: var(--brand-tint); border: 1px solid var(--brand-tint-2)">
                  Espécie
                </button>
                <button type="button" (click)="pgProcessarPagamento()" [disabled]="pgProcessing"
                        class="rounded-full px-5 text-white flex items-center gap-2"
                        style="height: 38px; font-size: 13px; font-weight: 700"
                        [style.background-color]="pgProcessing ? '#E5DFD4' : 'var(--brand-secondary)'"
                        [style.color]="pgProcessing ? '#8796A1' : '#fff'"
                        [style.cursor]="pgProcessing ? 'not-allowed' : 'pointer'"
                        title="Vincula o crédito do paciente à conta">
                  <div *ngIf="pgProcessing" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2" style="border-color: #8796A1"></div>
                  {{ pgProcessing ? 'Processando...' : 'Processar pagamento' }}
                </button>
              </div>
            </div>

          </ng-container>

          <!-- Sem dados de conta -->
          <div *ngIf="!pgDados && !pgLoading && !pgErro"
               class="flex flex-col items-center text-center rounded-xl py-10" style="border: 1px dashed var(--flua-borda)">
            <p style="font-size: 14px; font-weight: 600; color: var(--tx-2)">Nenhuma conta encontrada para este atendimento.</p>
            <button type="button" (click)="voltarParaContas()" class="chip-v2 ativo mt-3">{{ contasDoHistorico ? 'Voltar ao histórico' : 'Voltar às contas' }}</button>
          </div>

          <!-- ═══ Step 5 — Conclusão (após pagamento processado) ═══ -->
          <div *ngIf="pgResultado && !pgLoading" class="space-y-4">

            <!-- Banner verde -->
            <div class="rounded-2xl px-5 py-4 flex items-center gap-3" style="background-color: var(--brand-secondary)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                   stroke-width="2" stroke="white" class="size-7 shrink-0">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
              </svg>
              <div class="flex-1">
                <p class="font-semibold text-white text-sm">Pagamento Processado com Sucesso!</p>
                <div class="flex gap-4 mt-1 text-xs text-white/90">
                  <span>Atendimento: <strong class="text-white">#{{ pagandoConta?.nrAtendimento }}</strong></span>
                  <span>Valor: <strong class="text-white">{{ formatCurrencyDash(pgResultado.vlContaFinal) }}</strong></span>
                  <span>Título: <strong class="text-white">#{{ pgResultado.nrTitulo || '—' }}</strong></span>
                </div>
              </div>
            </div>

            <!-- Info bar: Paciente + Atendimento -->
            <div class="rounded-2xl px-5 py-3 flex items-center gap-6 text-xs"
                 style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
              <div class="flex items-center gap-1.5">
                <span class="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white" style="background-color: var(--brand-secondary)">1</span>
                <div><span class="uppercase font-semibold" style="color: var(--tx-2)">Paciente</span>
                  <p class="font-semibold" style="color: var(--tx)">{{ detalhesPaciente?.nmPessoaFisica }}</p></div>
              </div>
              <div class="flex items-center gap-1.5">
                <span class="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white" style="background-color: var(--brand-secondary)">2</span>
                <div><span class="uppercase font-semibold" style="color: var(--tx-2)">Atendimento</span>
                  <p class="font-semibold" style="color: var(--tx)">#{{ pagandoConta!.nrAtendimento }}</p></div>
              </div>
            </div>

            <!-- Loading resumo -->
            <div *ngIf="pgLoadingResumo" class="flex justify-center py-4">
              <div class="animate-spin rounded-full h-6 w-6 border-b-2" style="border-color: var(--brand-secondary)"></div>
            </div>

            <!-- Cards: Resumo Financeiro + Baixa/Pagamento -->
            <div class="grid grid-cols-2 gap-4">
              <!-- Resumo Financeiro -->
              <div class="rounded-2xl p-5 shadow" style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
                <div class="flex items-center gap-2 mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                       stroke-width="1.5" style="stroke: var(--brand-accent)" class="size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/>
                  </svg>
                  <span class="text-sm font-semibold" style="color: var(--brand-accent)">Resumo Financeiro</span>
                </div>
                <div class="space-y-2 text-sm">
                  <div class="flex justify-between">
                    <span style="color: var(--tx-2)">Valor da conta</span>
                    <span class="font-semibold" style="color: var(--tx)">{{ formatCurrencyDash(pgResumo?.vlConta ?? pgResultado.vlContaFinal) }}</span>
                  </div>
                  <div class="flex justify-between">
                    <span style="color: var(--tx-2)">Baixado</span>
                    <span class="font-semibold" style="color: var(--tx)">{{ formatCurrencyDash(pgResumo?.vlBaixado ?? pgResultado.vlContaFinal) }}</span>
                  </div>
                  <div class="flex justify-between">
                    <span style="color: var(--tx-2)">Saldo Pendente</span>
                    <span class="font-semibold" [style.color]="(pgResumo?.vlSaldoPendente ?? 0) <= 0 ? '#00AC70' : '#dc2626'">
                      {{ (pgResumo?.vlSaldoPendente ?? 0) <= 0 ? '✓ Quitado' : formatCurrencyDash(pgResumo?.vlSaldoPendente ?? 0) }}
                    </span>
                  </div>
                  <div class="flex justify-between">
                    <span style="color: var(--tx-2)">Status</span>
                    <span class="font-semibold" style="color: var(--tx)">{{ pgResumo?.statusConta || 'Definitivo' }}</span>
                  </div>
                </div>
              </div>

              <!-- Baixa / Pagamento -->
              <div class="rounded-2xl p-5 shadow" style="background-color: var(--cartao); border: 1px solid var(--flua-borda)">
                <div class="flex items-center gap-2 mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                       stroke-width="1.5" style="stroke: var(--brand-secondary)" class="size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"/>
                  </svg>
                  <span class="text-sm font-semibold" style="color: var(--brand-accent)">Baixa / Pagamento</span>
                </div>
                <div class="space-y-2 text-sm">
                  <div class="flex justify-between">
                    <span style="color: var(--tx-2)">Título</span>
                    <span class="font-semibold" style="color: var(--tx)">#{{ pgResultado.nrTitulo || '—' }}</span>
                  </div>
                  <div class="flex justify-between">
                    <span style="color: var(--tx-2)">Total</span>
                    <span class="font-semibold" style="color: var(--tx)">{{ formatCurrencyDash(pgResultado.vlContaFinal) }}</span>
                  </div>
                  <div class="flex justify-between">
                    <span style="color: var(--tx-2)">Baixado</span>
                    <span class="font-semibold" style="color: var(--tx)">{{ formatCurrencyDash(pgResumo?.vlBaixado ?? pgResultado.vlContaFinal) }}</span>
                  </div>
                  <div class="flex justify-between">
                    <span style="color: var(--tx-2)">Saldo Pendente</span>
                    <span class="font-semibold" [style.color]="(pgResumo?.vlSaldoPendente ?? 0) <= 0 ? '#00AC70' : '#dc2626'">
                      {{ (pgResumo?.vlSaldoPendente ?? 0) <= 0 ? '✓ Quitado' : formatCurrencyDash(pgResumo?.vlSaldoPendente ?? 0) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Adiantamentos Aplicados (se houver) -->
            <div *ngIf="pgResumo?.adiantamentosAplicados?.length"
                 class="rounded-2xl shadow overflow-hidden" style="border: 1px solid var(--flua-borda)">
              <div class="px-5 py-3 flex items-center gap-2" style="background-color: var(--cartao)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke-width="1.5" stroke="#f59e0b" class="size-5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3"/>
                </svg>
                <span class="text-sm font-semibold" style="color: var(--brand-accent)">Adiantamentos Aplicados</span>
              </div>
              <table class="w-full text-xs" style="border-top: 1px solid var(--flua-borda)">
                <thead>
                  <tr style="background-color: var(--thead); color: white">
                    <th class="px-3 py-2.5 text-left font-semibold">N°</th>
                    <th class="px-3 py-2.5 text-left font-semibold">Data</th>
                    <th class="px-3 py-2.5 text-left font-semibold">Estabelecimento</th>
                    <th class="px-3 py-2.5 text-right font-semibold">Vl. Original</th>
                    <th class="px-3 py-2.5 text-right font-semibold">Saldo Atual</th>
                    <th class="px-3 py-2.5 text-left font-semibold">Obs.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let adian of pgResumo!.adiantamentosAplicados; let odd = odd"
                      [style.background-color]="odd ? '#F9F5EC' : 'white'">
                    <td class="px-3 py-2.5 font-semibold" style="color: var(--brand-primary)">#{{ adian.nrAdiantamento }}</td>
                    <td class="px-3 py-2.5" style="color: var(--tx-2)">{{ adian.dtAdiantamento }}</td>
                    <td class="px-3 py-2.5" style="color: var(--tx)">{{ adian.estabelecimento }}</td>
                    <td class="px-3 py-2.5 text-right font-semibold" style="color: var(--tx)">{{ formatCurrencyDash(adian.vlOriginal) }}</td>
                    <td class="px-3 py-2.5 text-right" style="color: var(--tx-2)">{{ formatCurrencyDash(adian.vlSaldoAtual) }}</td>
                    <td class="px-3 py-2.5" style="color: var(--tx-2)">{{ adian.dsObservacao || '—' }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr style="background-color: var(--brand-surface); border-top: 2px solid var(--flua-borda)">
                    <td colspan="3" class="px-3 py-2.5 text-right font-bold text-xs" style="color: var(--brand-accent)">
                      TOTAL ({{ pgResumo!.adiantamentosAplicados.length }} {{ pgResumo!.adiantamentosAplicados.length === 1 ? 'adiantamento' : 'adiantamentos' }}):
                    </td>
                    <td class="px-3 py-2.5 text-right font-bold text-xs" style="color: var(--brand-secondary)">
                      {{ formatCurrencyDash(pgSumAdianOriginal()) }}
                    </td>
                    <td class="px-3 py-2.5 text-right font-bold text-xs" style="color: var(--tx-2)">
                      {{ formatCurrencyDash(pgSumAdianSaldoAtual()) }}
                    </td>
                    <td class="px-3 py-2.5"></td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <!-- Nota Fiscal (se houver) -->
            <div *ngIf="pgResumo?.notasFiscais?.length"
                 class="rounded-2xl shadow overflow-hidden" style="border: 1px solid var(--flua-borda)">
              <div class="px-5 py-3 flex items-center gap-2" style="background-color: var(--cartao)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke-width="1.5" style="stroke: var(--brand-accent)" class="size-5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/>
                </svg>
                <span class="text-sm font-semibold" style="color: var(--brand-accent)">Nota Fiscal</span>
              </div>
              <table class="w-full text-xs" style="border-top: 1px solid var(--flua-borda)">
                <thead>
                  <tr style="background-color: var(--thead); color: white">
                    <th class="px-3 py-2.5 text-left font-semibold">NF</th>
                    <th class="px-3 py-2.5 text-left font-semibold">RPS</th>
                    <th class="px-3 py-2.5 text-left font-semibold">Emissão</th>
                    <th class="px-3 py-2.5 text-right font-semibold">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let nf of pgResumo!.notasFiscais; let odd = odd"
                      [style.background-color]="odd ? '#F9F5EC' : 'white'">
                    <td class="px-3 py-2.5" style="color: var(--tx)">{{ nf.nrNotaFiscal || '—' }}</td>
                    <td class="px-3 py-2.5" style="color: var(--tx-2)">{{ nf.nrRps }}</td>
                    <td class="px-3 py-2.5" style="color: var(--tx-2)">{{ nf.dtEmissao }}</td>
                    <td class="px-3 py-2.5 text-right font-semibold" style="color: var(--tx)">{{ formatCurrencyDash(nf.vlNota) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Botões: Ver Ficha (PDF) + Concluir -->
            <div class="flex justify-end gap-3">
              <button (click)="pgVerFichaPdf()"
                      class="px-5 py-2.5 rounded-lg text-sm font-semibold flex items-center gap-2"
                      style="background-color: var(--cartao); color: var(--brand-accent); border: 1px solid var(--flua-borda)"
                      onmouseover="this.style.backgroundColor='var(--brand-surface)'"
                      onmouseout="this.style.backgroundColor='white'">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" class="size-4">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/>
                </svg>
                Ver Ficha (PDF)
              </button>
              <button (click)="voltarParaContas()"
                      class="px-6 py-2.5 rounded-lg text-white text-sm font-semibold flex items-center gap-2"
                      style="background-color: var(--brand-secondary)"
                      onmouseover="this.style.filter='brightness(0.9)'"
                      onmouseout="this.style.filter=''">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" class="size-4">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
                </svg>
                Concluir
              </button>
            </div>
          </div>

        </div>
      </ng-container>

    </div>
  </div>
</div>

<!-- ════════════════════════════════════════════════════════════
     MODAL — CUPONS (Pagamento de Conta no Dashboard)
     ════════════════════════════════════════════════════════════ -->
<div *ngIf="pgShowCupomModal"
     class="fixed inset-0 z-[60] flex items-center justify-center"
     style="background-color: rgba(0,0,0,0.5)">
  <div class="bg-white rounded-2xl shadow-xl w-full max-w-md max-h-[80vh] flex flex-col"
       (click)="$event.stopPropagation()">
    <div class="px-5 py-4 flex items-center justify-between" style="border-bottom: 1px solid var(--flua-borda); flex-shrink: 0">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="1.5" stroke="#f59e0b" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"/>
        </svg>
        <span class="font-semibold text-sm" style="color: var(--tx)">Cupons Disponíveis</span>
      </div>
      <button (click)="pgShowCupomModal = false" class="p-1 rounded-lg hover:bg-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="#4A5D6B" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
    <div class="px-5 py-4 overflow-y-auto flex-1 space-y-3" style="min-height: 100px">
      <div *ngIf="pgLoadingCupons" class="flex justify-center py-6">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2" style="border-color: #f59e0b"></div>
      </div>
      <div *ngIf="!pgLoadingCupons && pgCupons.length === 0" class="text-center py-6">
        <p class="text-sm" style="color: var(--tx-2)">Nenhum cupom disponível para este paciente.</p>
      </div>
      <div *ngFor="let cupom of pgCupons" class="rounded-xl p-4" style="border: 1px solid var(--flua-borda); background-color: var(--cartao)">
        <div class="flex items-start justify-between">
          <div class="flex-1">
            <p class="text-sm font-semibold" style="color: var(--tx)">{{ cupom.descCupom }}</p>
            <p *ngIf="cupom.dtExpiracao" class="text-xs mt-0.5" style="color: var(--tx-2)">Válido até {{ cupom.dtExpiracao }}</p>
          </div>
          <div class="text-right">
            <p class="text-lg font-bold" style="color: #f59e0b">{{ formatCurrencyDash(cupom.valor) }}</p>
            <p class="text-[10px]" style="color: var(--tx-2)">de desconto</p>
          </div>
        </div>
        <button (click)="pgAplicarCupom(cupom)" [disabled]="pgAplicandoCupom"
                class="mt-3 w-full py-2 rounded-lg text-xs font-semibold text-white flex items-center justify-center gap-1.5"
                [style.backgroundColor]="pgAplicandoCupom ? '#D6CFC2' : 'var(--brand-primary)'"
                [style.cursor]="pgAplicandoCupom ? 'not-allowed' : 'pointer'">
          <div *ngIf="pgAplicandoCupom" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
          {{ pgAplicandoCupom ? 'Aplicando...' : 'Aplicar Cupom' }}
        </button>
      </div>
    </div>
  </div>
</div>


<!-- ════════════════════════════════════════════════════════════
     MODAL — COBRAR NA MAQUINETA (Pagamento de Conta no Dashboard)
     ════════════════════════════════════════════════════════════ -->
<div *ngIf="pgShowMaquinetaModal"
     class="fixed inset-0 z-[60] flex items-center justify-center"
     style="background-color: rgba(0,0,0,0.5)">
  <div class="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 overflow-hidden"
       (click)="$event.stopPropagation()">
    <div class="px-5 py-4 flex items-center justify-between" style="background-color: var(--brand-secondary)">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="1.5" stroke="white" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"/>
        </svg>
        <span class="font-semibold text-sm text-white">Cobrar na Maquineta</span>
      </div>
      <button (click)="pgShowMaquinetaModal = false; pgAguardandoMaquineta = false" style="color: white" class="p-1">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
    <!-- Aguardando -->
    <div *ngIf="pgAguardandoMaquineta" class="px-5 py-8 text-center">
      <div class="animate-pulse mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="1" stroke="var(--ok)" class="size-16 mx-auto">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"/>
        </svg>
      </div>
      <p class="font-semibold text-sm" style="color: var(--tx)">Aguardando na maquineta...</p>
      <p class="text-xs mt-1" style="color: var(--tx-2)">Peça ao cliente para inserir ou aproximar o cartão</p>
      <button (click)="pgFinalizarMaquineta()"
              class="mt-6 w-full py-2.5 rounded-lg text-sm font-semibold text-white"
              style="background-color: var(--brand-secondary)">
        Pagamento Concluído — Fechar
      </button>
    </div>
    <!-- Formulário -->
    <div *ngIf="!pgAguardandoMaquineta" class="px-5 py-5 space-y-4">
      <div class="rounded-lg p-3 text-center" style="background-color: #f0fdf4; border: 1px solid #bbf7d0">
        <p class="text-xs mb-1" style="color: var(--tx-2)">Valor a cobrar</p>
        <div class="flex items-center justify-center gap-1">
          <span class="text-lg font-bold" style="color: var(--brand-secondary)">R$</span>
          <input type="number" [(ngModel)]="pgMaquinetaValor"
                 (ngModelChange)="pgOnMaquinetaValorChange()"
                 min="0.01" [max]="pgDados?.vlTotalConta || 0"
                 step="0.01"
                 class="text-2xl font-bold text-center border-b-2 bg-transparent outline-none"
                 style="color: var(--brand-secondary); border-color: #bbf7d0; width: 160px"
                 (focus)="$any($event.target).select()"/>
        </div>
        <p *ngIf="pgMaquinetaValor < (pgDados?.vlTotalConta || 0)" class="text-[10px] mt-1" style="color: var(--tx-2)">
          Total da conta: {{ formatCurrencyDash(pgDados?.vlTotalConta || 0) }} — Restante: {{ formatCurrencyDash((pgDados?.vlTotalConta || 0) - pgMaquinetaValor) }}
        </p>
      </div>
      <div>
        <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Forma de Pagamento</label>
        <div class="flex gap-2">
          <button (click)="pgMaquinetaMetodo = 1; pgMaquinetaParcelas = 1"
                  class="flex-1 py-2 rounded-lg text-xs font-semibold text-center"
                  [style.backgroundColor]="pgMaquinetaMetodo === 1 ? 'var(--brand-secondary)' : 'white'"
                  [style.color]="pgMaquinetaMetodo === 1 ? 'white' : '#4A5D6B'"
                  [style.border]="'1px solid ' + (pgMaquinetaMetodo === 1 ? 'var(--brand-secondary)' : '#E5DFD4')">Crédito</button>
          <button (click)="pgMaquinetaMetodo = 2; pgMaquinetaParcelas = 1"
                  class="flex-1 py-2 rounded-lg text-xs font-semibold text-center"
                  [style.backgroundColor]="pgMaquinetaMetodo === 2 ? 'var(--brand-secondary)' : 'white'"
                  [style.color]="pgMaquinetaMetodo === 2 ? 'white' : '#4A5D6B'"
                  [style.border]="'1px solid ' + (pgMaquinetaMetodo === 2 ? 'var(--brand-secondary)' : '#E5DFD4')">Débito</button>
        </div>
      </div>
      <div *ngIf="pgMaquinetaMetodo === 1">
        <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Parcelas</label>
        <div class="grid grid-cols-5 gap-1">
          <button *ngFor="let p of pgParcelasDisponiveis" (click)="pgMaquinetaParcelas = p"
                  class="py-1.5 rounded text-xs font-semibold text-center"
                  [style.backgroundColor]="pgMaquinetaParcelas === p ? 'var(--brand-secondary)' : 'white'"
                  [style.color]="pgMaquinetaParcelas === p ? 'white' : '#4A5D6B'"
                  [style.border]="'1px solid ' + (pgMaquinetaParcelas === p ? 'var(--brand-secondary)' : '#E5DFD4')">{{ p }}x</button>
        </div>
        <p *ngIf="pgDados && pgMaquinetaParcelas > 1" class="text-[10px] mt-1" style="color: var(--tx-2)">
          {{ pgMaquinetaParcelas }}x de {{ formatCurrencyDash((pgMaquinetaValor || 0) / pgMaquinetaParcelas) }}
        </p>
        <p *ngIf="pgParcelasDisponiveis.length === 1" class="text-[10px] mt-1" style="color: var(--tx-2)">
          Parcelamento mínimo: {{ formatCurrencyDash(pgParcelaMinimaAtual) }} por parcela
        </p>
      </div>
      <div>
        <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Terminal (Maquineta)</label>
        <div class="flex gap-2 mb-2">
          <button (click)="pgSelecionarTerminalTipo('V240mPlus')"
                  class="px-3 py-1.5 rounded text-xs font-semibold"
                  [style.backgroundColor]="pgMaquinetaTerminalTipo === 'V240mPlus' ? 'var(--brand-secondary)' : 'white'"
                  [style.color]="pgMaquinetaTerminalTipo === 'V240mPlus' ? 'white' : '#4A5D6B'"
                  [style.border]="'1px solid ' + (pgMaquinetaTerminalTipo === 'V240mPlus' ? 'var(--brand-secondary)' : '#E5DFD4')">V240mPlus</button>
          <button (click)="pgSelecionarTerminalTipo('P400Plus')"
                  class="px-3 py-1.5 rounded text-xs font-semibold"
                  [style.backgroundColor]="pgMaquinetaTerminalTipo === 'P400Plus' ? 'var(--brand-secondary)' : 'white'"
                  [style.color]="pgMaquinetaTerminalTipo === 'P400Plus' ? 'white' : '#4A5D6B'"
                  [style.border]="'1px solid ' + (pgMaquinetaTerminalTipo === 'P400Plus' ? 'var(--brand-secondary)' : '#E5DFD4')">P400Plus</button>
          <button (click)="pgSelecionarTerminalTipo('S1F2')"
                  class="px-3 py-1.5 rounded text-xs font-semibold"
                  [style.backgroundColor]="pgMaquinetaTerminalTipo === 'S1F2' ? 'var(--brand-secondary)' : 'white'"
                  [style.color]="pgMaquinetaTerminalTipo === 'S1F2' ? 'white' : '#4A5D6B'"
                  [style.border]="'1px solid ' + (pgMaquinetaTerminalTipo === 'S1F2' ? 'var(--brand-secondary)' : '#E5DFD4')">S1F2</button>
        </div>
        <div class="relative">
          <div class="flex items-center rounded-lg border overflow-hidden" style="border-color: var(--flua-borda)">
            <span class="px-2 py-2 text-xs bg-gray-50" style="color: var(--tx-2); border-right: 1px solid var(--flua-borda)">{{ pgMaquinetaTerminalTipo }}-</span>
            <input type="text" [(ngModel)]="pgMaquinetaTerminalNumero"
                   (input)="pgFiltrarTerminais()" (focus)="pgFiltrarTerminais()"
                   placeholder="Digite os últimos dígitos..."
                   class="flex-1 text-xs px-2 py-2" style="outline: none; color: var(--tx)"/>
          </div>
          <div *ngIf="pgShowTerminalDropdown"
               class="absolute z-10 left-0 right-0 mt-1 rounded-lg shadow-lg overflow-hidden"
               style="background-color: var(--cartao); border: 1px solid var(--flua-borda); max-height: 180px; overflow-y: auto">
            <div *ngFor="let t of pgMaquinetaTerminaisFiltrados"
                 (mousedown)="pgSelecionarTerminal(t)"
                 class="px-3 py-2 text-xs cursor-pointer hover:bg-gray-100 flex justify-between"
                 style="color: var(--tx)">
              <span>{{ t.tipo }}-<strong>{{ t.numero }}</strong></span>
              <span class="text-[10px]" style="color: var(--tx-2)">{{ t.loja }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!pgAguardandoMaquineta" class="px-5 py-4 flex justify-end gap-2" style="border-top: 1px solid var(--flua-borda)">
      <button (click)="pgShowMaquinetaModal = false" class="px-4 py-2 rounded-lg text-xs font-semibold"
              style="border: 1px solid var(--flua-borda); color: var(--tx-2)">Cancelar</button>
      <button (click)="pgEnviarMaquineta()"
              [disabled]="pgEnviandoMaquineta || !pgMaquinetaTerminalFull"
              class="px-5 py-2 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5"
              style="background-color: var(--brand-secondary)"
              [style.opacity]="pgEnviandoMaquineta || !pgMaquinetaTerminalFull ? 0.5 : 1"
              [style.cursor]="pgEnviandoMaquineta || !pgMaquinetaTerminalFull ? 'not-allowed' : 'pointer'">
        <div *ngIf="pgEnviandoMaquineta" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
        {{ pgEnviandoMaquineta ? 'Enviando...' : 'Enviar para Maquineta' }}
      </button>
    </div>
  </div>
</div>

<!-- ════════════════════════════════════════════════════════════
     MODAL — SELECIONAR ORÇAMENTO (Pagamento de Conta no Dashboard)
     ════════════════════════════════════════════════════════════ -->
<div *ngIf="pgShowOrcamentoModal"
     class="fixed inset-0 z-[60] flex justify-center"
     style="background-color: rgba(0,0,0,0.5); overflow-y: auto; padding: 40px 0">
  <div class="rounded-2xl shadow-xl w-full max-w-lg mx-4"
       style="background-color: var(--cartao); height: fit-content; align-self: flex-start"
       (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="px-5 py-4 flex items-center justify-between"
         style="border-bottom: 1px solid var(--flua-borda); background-color: var(--brand-surface); border-radius: 16px 16px 0 0">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="1.5" stroke="var(--brand-primary)" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/>
        </svg>
        <p class="font-semibold text-sm" style="color: var(--tx)">Selecionar Orçamento</p>
      </div>
      <button (click)="pgShowOrcamentoModal = false"
              class="p-1 rounded-lg" style="color: var(--tx-2)"
              onmouseover="this.style.backgroundColor='#F4F1EA'"
              onmouseout="this.style.backgroundColor='transparent'">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
    <!-- Body -->
    <div class="px-5 py-4 flex flex-col gap-4">
      <div *ngIf="pgLoadingOrcamentos" class="flex justify-center py-10">
        <div class="h-8 w-8 animate-spin rounded-full border-4 border-gray-200"
             style="border-top-color: var(--brand-primary)"></div>
      </div>
      <div *ngIf="!pgLoadingOrcamentos && pgOrcamentoGroups.length === 0"
           class="flex flex-col items-center py-10 gap-2" style="color: var(--tx-2)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="1.5" stroke="currentColor" class="size-10 opacity-30">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/>
        </svg>
        <p class="text-sm">Nenhum orçamento encontrado nos últimos 365 dias.</p>
      </div>
      <div *ngFor="let group of pgOrcamentoGroups"
           class="rounded-xl overflow-hidden" style="border: 1px solid var(--flua-borda)">
        <div class="px-4 py-3 flex items-center justify-between"
             style="background-color: var(--brand-surface); border-bottom: 1px solid var(--flua-borda)">
          <div>
            <p class="text-sm font-semibold" style="color: var(--tx)">Orçamento #{{ group.nrSequenciaOrcamento }}</p>
            <p class="text-xs mt-0.5" style="color: var(--tx-2)">{{ group.dtOrcamento | date:'dd/MM/yyyy' }}</p>
          </div>
          <div class="text-right">
            <p class="text-sm font-bold" style="color: var(--brand-primary)">{{ formatCurrencyDash(pgIsParticular ? group.totalVista : group.totalCartao) }}</p>
            <label class="flex items-center gap-1 text-xs cursor-pointer" style="color: var(--tx-2)">
              <input type="checkbox"
                     [checked]="pgTodosSelecionados(group)"
                     (change)="pgToggleTodosOrcamento(group)"
                     class="accent-[var(--brand-primary)]"/>
              Todos
            </label>
          </div>
        </div>
        <div class="divide-y" style="border-color: #F4F1EA">
          <div *ngFor="let proc of group.procedimentos"
               class="px-4 py-2.5 flex items-center gap-3" style="background-color: var(--cartao)">
            <input type="checkbox" [(ngModel)]="proc.selecionado" class="accent-[var(--brand-primary)] flex-shrink-0"/>
            <div class="flex-1 min-w-0">
              <p class="text-xs font-medium truncate" style="color: var(--tx)">{{ proc.dsProcedimento }}</p>
              <p class="text-xs" style="color: var(--tx-2)">Qtd: {{ proc.qtProcedimento }}</p>
            </div>
            <p class="text-xs font-semibold flex-shrink-0" style="color: var(--brand-secondary)">{{ formatCurrencyDash(pgIsParticular ? proc.vlVista : proc.vlCartao) }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <div class="px-5 py-4 flex items-center justify-between gap-3"
         style="border-top: 1px solid var(--flua-borda); background-color: var(--brand-surface); flex-shrink: 0">
      <span class="text-xs" style="color: var(--tx-2)">{{ pgTotalSelecionadosOrcamento }} procedimento(s) selecionado(s)</span>
      <button (click)="pgInserirSelecionadosOrcamento()"
              [disabled]="pgTotalSelecionadosOrcamento === 0 || pgInserindoOrcamento"
              class="px-5 py-2 rounded-lg text-white text-sm font-semibold flex items-center gap-2 transition-opacity"
              [style.backgroundColor]="pgTotalSelecionadosOrcamento === 0 || pgInserindoOrcamento ? '#D6CFC2' : 'var(--brand-primary)'"
              [style.cursor]="pgTotalSelecionadosOrcamento === 0 || pgInserindoOrcamento ? 'not-allowed' : 'pointer'"
              onmouseover="if(!this.disabled) this.style.backgroundColor='var(--brand-ink)'"
              onmouseout="if(!this.disabled) this.style.backgroundColor='var(--brand-primary)'">
        <div *ngIf="pgInserindoOrcamento" class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
        <svg *ngIf="!pgInserindoOrcamento" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
        </svg>
        {{ pgInserindoOrcamento ? 'Adicionando...' : 'Inserir Selecionados' }}
      </button>
    </div>
  </div>
</div>

<!-- ════════════════════════════════════════════════════════════
     MODAL — VINCULAR ADIANTAMENTO
     ════════════════════════════════════════════════════════════ -->
<div *ngIf="pgShowVincularModal"
     class="fixed inset-0 z-[60] flex items-center justify-center"
     style="background-color: rgba(0,0,0,0.5)">
  <div class="bg-white rounded-2xl shadow-xl w-full max-w-lg mx-4 max-h-[85vh] flex flex-col overflow-hidden"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="px-5 py-4 flex items-center justify-between" style="flex-shrink: 0; border-bottom: 1px solid var(--flua-borda)">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="1.5" stroke="var(--brand-secondary)" class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"/>
        </svg>
        <span class="font-semibold text-sm" style="color: var(--tx)">Vincular Adiantamento</span>
      </div>
      <div class="flex items-center gap-1">
        <button (click)="pgAtualizarAdiantamentos()" [disabled]="pgAtualizandoAdiantamentos || pgBuscaAdiantamentos.bloqueioManual > 0" title="Buscar os adiantamentos de novo"
                class="px-2.5 py-1 rounded-lg text-xs font-semibold flex items-center gap-1"
                style="border: 1px solid var(--brand-secondary); color: var(--brand-secondary)"
                [class.animate-pulse]="pgBuscaAdiantamentos.encerrada && pgBuscaAdiantamentos.bloqueioManual === 0"
                [style.boxShadow]="pgBuscaAdiantamentos.encerrada ? '0 0 0 3px rgba(0,172,112,.25)' : null"
                [style.opacity]="pgAtualizandoAdiantamentos || pgBuscaAdiantamentos.bloqueioManual > 0 ? 0.5 : 1"
                [style.cursor]="pgAtualizandoAdiantamentos || pgBuscaAdiantamentos.bloqueioManual > 0 ? 'not-allowed' : 'pointer'">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
               stroke="currentColor" class="size-3.5" [class.animate-spin]="pgAtualizandoAdiantamentos">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
          </svg>
          {{ pgBuscaAdiantamentos.bloqueioManual > 0 ? 'Aguarde ' + pgBuscaAdiantamentos.bloqueioManual + 's' : 'Atualizar' }}
        </button>
        <button (click)="pgFecharVincularModal()" class="p-1 rounded-lg hover:bg-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="2" stroke="#4A5D6B" class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Info da conta -->
    <div class="px-5 py-3" style="background-color: var(--brand-surface); border-bottom: 1px solid var(--flua-borda); flex-shrink: 0">
      <div class="flex justify-between text-sm">
        <span style="color: var(--tx-2)">Conta: <strong style="color: var(--tx)">{{ pgDados?.nrInternoConta }}</strong></span>
        <span style="color: var(--tx-2)">Saldo Pendente: <strong [style.color]="(pgDados?.vlSaldo ?? 0) <= 0 ? '#00AC70' : '#dc2626'">{{ (pgDados?.vlSaldo ?? 0) <= 0 ? '✓ Quitado' : formatCurrencyDash(pgDados?.vlSaldo ?? 0) }}</strong></span>
      </div>
    </div>

    <!-- Status da busca automática -->
    <div *ngIf="(pgBuscaAdiantamentos.procurando || pgBuscaAdiantamentos.encerrada || pgAdiantamentosNovos.size > 0) && !pgVincularSucesso" class="px-5 py-2 flex items-center gap-2 text-xs"
         style="flex-shrink: 0; border-bottom: 1px solid var(--flua-borda)"
         [style.backgroundColor]="pgAdiantamentosNovos.size > 0 ? '#f0fdf4' : pgBuscaAdiantamentos.encerrada ? '#FFF8E1' : 'transparent'">
      <span *ngIf="pgAdiantamentosNovos.size > 0; else pgFaixaBusca" class="font-semibold" style="color: #059669">
        ✓ {{ pgAdiantamentosNovos.size }} {{ pgAdiantamentosNovos.size > 1 ? 'adiantamentos novos encontrados' : 'adiantamento novo encontrado' }}
      </span>
      <ng-template #pgFaixaBusca>
        <ng-container *ngIf="pgBuscaAdiantamentos.procurando">
          <span class="relative flex h-2 w-2">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75" style="background-color: #00AC70"></span>
            <span class="relative inline-flex rounded-full h-2 w-2" style="background-color: #00AC70"></span>
          </span>
          <span style="color: var(--tx-2)">Atualizando automaticamente · próxima busca em {{ pgBuscaAdiantamentos.segundosParaProxima }}s</span>
        </ng-container>
        <ng-container *ngIf="pgBuscaAdiantamentos.encerrada">
          <span style="color: #8A6D00">Não encontrou o adiantamento do pagamento?</span>
          <button (click)="pgAtualizarAdiantamentos()" [disabled]="pgBuscaAdiantamentos.bloqueioManual > 0" class="font-semibold underline"
                  style="color: var(--brand-secondary)">Atualizar</button>
        </ng-container>
      </ng-template>
    </div>

    <!-- Tela de Sucesso -->
    <ng-container *ngIf="pgVincularSucesso && pgVincularResumo">
      <div class="px-5 py-6 flex-1 flex flex-col items-center justify-center text-center">
        <div class="rounded-full p-3 mb-4" style="background-color: #dcfce7">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="2" stroke="var(--ok)" class="size-10">
            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
          </svg>
        </div>
        <p class="text-lg font-bold mb-1" style="color: var(--ok)">Vinculado com Sucesso!</p>
        <p class="text-xs mb-5" style="color: var(--tx-2)">Adiantamento vinculado ao título #{{ pgVincularResumo.nrTitulo }}</p>

        <div class="w-full rounded-xl p-4 space-y-3 text-sm" style="background-color: var(--brand-surface); border: 1px solid var(--flua-borda)">
          <div class="flex justify-between">
            <span style="color: var(--tx-2)">Título</span>
            <span class="font-semibold" style="color: var(--tx)">#{{ pgVincularResumo.nrTitulo }}</span>
          </div>
          <div class="flex justify-between">
            <span style="color: var(--tx-2)">Valor Vinculado</span>
            <span class="font-semibold" style="color: var(--brand-secondary)">{{ formatCurrencyDash(pgVincularResumo.vlVinculado) }}</span>
          </div>
          <div class="flex justify-between border-t pt-3" style="border-color: var(--flua-borda)">
            <span class="font-bold" style="color: var(--tx)">Saldo Pendente</span>
            <span class="font-bold" [style.color]="pgVincularResumo.vlSaldoPendente <= 0 ? '#059669' : '#dc2626'">
              {{ pgVincularResumo.vlSaldoPendente <= 0 ? '✓ Quitado' : formatCurrencyDash(pgVincularResumo.vlSaldoPendente) }}
            </span>
          </div>
        </div>
      </div>

      <div class="px-5 py-4 flex justify-center" style="border-top: 1px solid var(--flua-borda); flex-shrink: 0">
        <button (click)="pgFecharVincularModal()"
                class="px-6 py-2.5 rounded-lg text-sm font-semibold text-white"
                style="background-color: var(--brand-secondary)"
                onmouseover="this.style.filter='brightness(0.9)'"
                onmouseout="this.style.filter=''">
          Fechar
        </button>
      </div>
    </ng-container>

    <!-- Body (seleção de adiantamentos) -->
    <ng-container *ngIf="!pgVincularSucesso">
    <div class="px-5 py-4 overflow-y-auto flex-1">
      <p class="text-xs font-semibold mb-3" style="color: var(--tx)">Selecione o adiantamento:</p>

      <!-- Loading -->
      <div *ngIf="pgLoadingAdiantamentos" class="flex justify-center py-6">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2" style="border-color: var(--brand-secondary)"></div>
      </div>

      <!-- Vazio -->
      <div *ngIf="!pgLoadingAdiantamentos && pgAdiantamentos.length === 0" class="text-center py-6">
        <ng-container *ngIf="pgBuscaAdiantamentos.procurando; else pgSemAdiantamento">
          <div class="animate-spin rounded-full h-5 w-5 border-b-2 mx-auto mb-2" style="border-color: var(--brand-secondary)"></div>
          <p class="text-sm" style="color: var(--tx-2)">Procurando adiantamentos…</p>
          <p class="text-xs mt-1" style="color: var(--tx-2)">O pagamento pode levar alguns segundos para aparecer.</p>
        </ng-container>
        <ng-template #pgSemAdiantamento>
          <p class="text-sm" style="color: var(--tx-2)">Nenhum adiantamento disponível para este paciente.</p>
          <button (click)="pgAtualizarAdiantamentos()" [disabled]="pgBuscaAdiantamentos.bloqueioManual > 0" class="mt-2 text-xs font-semibold underline" style="color: var(--brand-secondary)">Procurar de novo</button>
        </ng-template>
      </div>

      <!-- Lista de adiantamentos -->
      <div *ngIf="!pgLoadingAdiantamentos" class="space-y-3">
        <div *ngFor="let adian of pgAdiantamentos"
             (click)="pgToggleAdiantamento(adian.nrAdiantamento)"
             class="rounded-xl p-4 cursor-pointer transition-all"
             [style.boxShadow]="pgAdiantamentosNovos.has(adian.nrAdiantamento) ? '0 0 0 3px rgba(0,172,112,.35)' : null"
             [style.border]="pgIsAdiantamentoSelecionado(adian.nrAdiantamento) ? '2px solid var(--brand-secondary)' : '1px solid #E5DFD4'"
             [style.backgroundColor]="pgIsAdiantamentoSelecionado(adian.nrAdiantamento) ? '#f0fdf4' : 'white'">
          <div class="flex items-start gap-3">
            <input type="checkbox" [checked]="pgIsAdiantamentoSelecionado(adian.nrAdiantamento)"
                   class="accent-[var(--brand-secondary)] mt-0.5 flex-shrink-0 pointer-events-none"/>
            <div class="flex-1 min-w-0">
              <p class="text-xs" style="color: var(--tx)">{{ adian.dsAdiantamento }}
                <span *ngIf="pgAdiantamentosNovos.has(adian.nrAdiantamento)" class="ml-1 px-1.5 py-0.5 rounded text-[10px] font-bold text-white"
                      style="background-color: var(--brand-secondary)">Novo</span>
              </p>
              <p class="text-sm font-bold mt-1" style="color: var(--brand-secondary)">
                Saldo disponível: {{ formatCurrencyDash(adian.vlSaldo) }}
              </p>
              <p class="text-xs mt-0.5" style="color: var(--tx-2)">
                → Saldo: {{ formatCurrencyDash(adian.vlSaldo) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Valor total selecionado -->
      <div *ngIf="pgTotalAdiantamentosSelecionados > 0"
           class="mt-4 rounded-lg p-3 text-sm"
           style="background-color: #f0fdf4; border: 1px solid #bbf7d0">
        <div class="flex justify-between">
          <span style="color: var(--tx-2)">Total selecionado ({{ pgTotalAdiantamentosSelecionados }})</span>
          <span class="font-bold" style="color: var(--brand-secondary)">{{ formatCurrencyDash(pgValorAdiantamentosSelecionados) }}</span>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-5 py-4 flex justify-end gap-2" style="border-top: 1px solid var(--flua-borda); flex-shrink: 0">
      <button (click)="pgFecharVincularModal()"
              class="px-4 py-2 rounded-lg text-xs font-semibold"
              style="border: 1px solid var(--flua-borda); color: var(--tx-2)">
        Cancelar
      </button>
      <button (click)="pgConfirmarVinculacao()"
              [disabled]="pgVinculando || pgTotalAdiantamentosSelecionados === 0"
              class="px-5 py-2 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5"
              style="background-color: var(--brand-secondary)"
              [style.opacity]="pgVinculando || pgTotalAdiantamentosSelecionados === 0 ? 0.5 : 1"
              [style.cursor]="pgVinculando || pgTotalAdiantamentosSelecionados === 0 ? 'not-allowed' : 'pointer'">
        <div *ngIf="pgVinculando" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
        <svg *ngIf="!pgVinculando" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="size-3.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
        </svg>
        {{ pgVinculando ? pgVincularProgresso : 'Confirmar' }}
      </button>
    </div>
    </ng-container>
  </div>
</div>

<!-- ════════════════════════════════════════════════════════════
     MODAL — BUSCA DE PACIENTE (Express → Abrir Atendimento)
     ════════════════════════════════════════════════════════════ -->
<div *ngIf="showBuscaPacienteModal"
     class="fixed inset-0 z-[350] flex items-center justify-center"
     style="background: rgba(16,24,32,.72); backdrop-filter: blur(6px)">
  <div role="dialog" aria-modal="true" aria-labelledby="tituloBuscaPaciente"
       class="bg-white dark:bg-[#10283A] w-[92vw] max-h-[85vh] flex flex-col"
       style="max-width: 600px; border-radius: 18px; box-shadow: 0 24px 60px -20px rgba(16,24,32,.5)"
       (click)="$event.stopPropagation()">

    <div class="flex items-start gap-3 px-7 pt-6 pb-4" style="flex-shrink: 0">
      <div class="flex-1">
        <p class="uppercase" style="font-size: 9px; font-weight: 800; letter-spacing: .12em; color: var(--brand-primary)">
          Senha Express
        </p>
        <h3 id="tituloBuscaPaciente" class="dark:text-white" style="font-size: 18px; font-weight: 700; margin-top: 2px">
          Buscar paciente
        </h3>
        <p style="font-size: 12px; color: var(--tx-2); margin-top: 4px">
          Informe o CPF ou nome do paciente para abrir o atendimento.
        </p>
      </div>
      <button type="button" (click)="showBuscaPacienteModal = false" title="Fechar"
              class="grid place-items-center rounded-full hover:bg-[#F4F1EA] dark:hover:bg-[#163247]"
              style="width: 32px; height: 32px; color: var(--tx-2)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <div class="px-7 pb-6 overflow-y-auto flex-1">
      <div class="relative">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="campo-busca-icone size-4">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/>
        </svg>
        <input type="text"
               [(ngModel)]="buscaPacienteQuery"
               (input)="onBuscaPacienteInput()"
               placeholder="Digite o CPF ou nome do paciente (mín. 3 caracteres)"
               class="campo-busca" />
        <div class="campo-busca-acao">
          <div *ngIf="isLoadingBuscaPaciente" class="animate-spin rounded-full h-4 w-4 border-b-2"
               style="border-color: var(--brand-primary)"></div>
          <button *ngIf="!isLoadingBuscaPaciente && buscaPacienteQuery"
                  type="button"
                  (click)="buscaPacienteQuery = ''; buscaPacienteResultados = []"
                  title="Limpar busca"
                  style="color: var(--brand-muted)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="2" stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Resultados -->
      <div *ngIf="buscaPacienteResultados.length > 0" class="mt-4 flex flex-col gap-2">
        <p style="font-size: 11px; font-weight: 600; color: var(--tx-2)">
          {{ buscaPacienteResultados.length }} {{ buscaPacienteResultados.length === 1 ? 'paciente encontrado' : 'pacientes encontrados' }}
        </p>
        <button *ngFor="let p of buscaPacienteResultados"
                type="button"
                (click)="selecionarPacienteBusca(p)"
                class="motivo-pausa paciente-busca flex items-center gap-3 text-left px-4 py-3">
          <span class="flex-1 min-w-0">
            <span class="block truncate dark:text-white" style="font-size: 14px; font-weight: 700; color: var(--tx)">
              {{ p.nmPessoaFisica }}
            </span>
            <span class="sub-paciente block">
              Cód. {{ p.cdPessoaFisica }} · CPF {{ p.nrCpf ? formatCpf(p.nrCpf) : '—' }}
            </span>
          </span>
          <span class="paciente-busca-acao shrink-0">Selecionar</span>
        </button>
      </div>

      <div *ngIf="!isLoadingBuscaPaciente && buscaPacienteQuery.trim().length >= 3 && buscaPacienteResultados.length === 0"
           class="mt-4 flex flex-col items-center text-center rounded-xl py-6 px-4"
           style="border: 1px dashed var(--flua-borda)">
        <p style="font-size: 14px; font-weight: 600; color: var(--tx-2)" class="dark:text-gray-200">Nenhum paciente encontrado</p>
        <p style="font-size: 12px; color: var(--tx-2); margin-top: 2px">Confira o CPF ou cadastre o paciente agora.</p>
        <button type="button" (click)="showCadastroPaciente = true"
                class="mt-3 px-5 text-white"
                style="height: 40px; border-radius: 10px; font-size: 13px; font-weight: 700; background-color: var(--brand-secondary)">
          Cadastrar paciente
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Menu do "⋯" da conta: fixo na tela, a tabela rola na horizontal e cortaria um absoluto -->
<ng-container *ngIf="contaMenu">
  <div class="fixed inset-0 z-[455]" (click)="contaMenu = null"></div>
  <div class="menu-acoes-conta z-[456]" [style.top.px]="contaMenu.top" [style.right.px]="contaMenu.right">
    <ng-container *ngIf="contaDefinitiva(contaMenu.conta); else menuProvisoria">
      <button type="button" class="perigo" (click)="abrirAcaoConta('cancelar', contaMenu.conta)">{{ rotuloCancelar(contaMenu.conta) }}</button>
    </ng-container>
    <ng-template #menuProvisoria>
      <button type="button" (click)="abrirAcaoConta('trocar', contaMenu!.conta)">Trocar convênio</button>
      <button *ngIf="contaMenu!.conta.cupomAplicado" type="button" class="perigo" (click)="abrirAcaoConta('remover-cupom', contaMenu!.conta)">Remover cupom</button>
      <button type="button" class="perigo" (click)="abrirAcaoConta('excluir', contaMenu!.conta)">Excluir conta</button>
    </ng-template>
  </div>
</ng-container>

<!-- Ações de supervisor na conta: cancelar, excluir provisória, trocar convênio -->
<div *ngIf="contaAcao" class="modal-v2-fundo z-[460] p-4">
  <div role="dialog" aria-modal="true" aria-labelledby="tituloAcaoConta" class="modal-v2" style="max-width: 500px">

    <div class="modal-v2-topo">
      <div class="flex-1 min-w-0">
        <p class="modal-v2-eyebrow">Supervisor · conta #{{ contaAcao.conta.nrInternoConta }}</p>
        <h3 id="tituloAcaoConta" class="modal-v2-titulo">
          {{ tituloAcaoConta(contaAcao) }}
        </h3>
        <p class="modal-v2-sub">
          Atendimento #{{ contaAcao.conta.nrAtendimento }} · {{ formatCurrencyDash(contaAcao.conta.vlConta) }} · {{ contaAcao.conta.estabelecimento }}
        </p>
      </div>
      <button type="button" (click)="fecharAcaoConta()" [disabled]="contaAcaoEnviando" title="Fechar" class="modal-v2-fechar">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <div class="px-7 pb-6 flex flex-col gap-4">

      <!-- Cancelar -->
      <ng-container *ngIf="contaAcao.tipo === 'cancelar'">
        <div *ngIf="contaAcao.conta.temTitulo || contaAcao.conta.temNf; else soVoltar" class="aviso-v2 vermelho">
          Os pagamentos da conta são <strong>estornados</strong>, o título é cancelado
          <ng-container *ngIf="contaAcao.conta.temNf">e a nota fiscal fica cancelada</ng-container>.
          O atendimento volta a ter uma conta provisória.
        </div>
        <ng-template #soVoltar>
          <div class="aviso-v2 ambar">A conta ainda não tem título nem nota fiscal: ela só volta a ser provisória.</div>
        </ng-template>
        <label>
          <span class="rotulo-v2">Motivo <span class="obrigatorio">*</span></span>
          <textarea [(ngModel)]="contaAcaoMotivo" rows="3" maxlength="1000" class="campo-v2" style="height: auto; padding: 10px 12px"
                    placeholder="Por que esta conta está sendo cancelada?"></textarea>
        </label>
      </ng-container>

      <!-- Excluir -->
      <ng-container *ngIf="contaAcao.tipo === 'excluir'">
        <div class="aviso-v2 vermelho">A conta provisória é excluída do Tasy. Esta ação não pode ser desfeita.</div>
        <div *ngIf="contaAcaoCupons.length" class="aviso-v2 ambar">
          <ng-container *ngIf="contaAcaoCupons.length === 1; else variosCupons">
            Esta conta tem o cupom <strong>{{ contaAcaoCupons[0].codCupom }}</strong> aplicado.
            Ao excluir, ele volta a ficar ativo para o paciente.
          </ng-container>
          <ng-template #variosCupons>
            Esta conta tem os cupons
            <strong>{{ codigosCupons(contaAcaoCupons) }}</strong> aplicados.
            Ao excluir, eles voltam a ficar ativos para o paciente.
          </ng-template>
        </div>
        <div role="radiogroup" aria-label="Motivo" class="flex flex-col gap-2">
          <span class="rotulo-v2">Motivo <span class="obrigatorio">*</span></span>
          <button *ngFor="let m of [['engano','Conta lançada por engano'],['desistiu','Paciente desistiu do atendimento'],['duplicidade','Conta duplicada'],['outro','Outro motivo']]"
                  type="button" role="radio" [attr.aria-checked]="contaAcaoTipoExclusao === m[0]"
                  (click)="contaAcaoTipoExclusao = $any(m[0])"
                  class="motivo-pausa flex items-center gap-2 text-left px-3" [class.selecionado]="contaAcaoTipoExclusao === m[0]">
            <span class="radio-motivo shrink-0" [class.marcado]="contaAcaoTipoExclusao === m[0]"></span>
            <span class="flex-1 py-2" style="font-size: 14px">{{ m[1] }}</span>
          </button>
        </div>
        <label *ngIf="contaAcaoTipoExclusao === 'duplicidade'">
          <span class="rotulo-v2">Conta que fica (a correta) <span class="obrigatorio">*</span></span>
          <select [(ngModel)]="contaAcaoContaRef" class="campo-v2">
            <option [ngValue]="null">Selecione</option>
            <option *ngFor="let c of contasParaReferencia" [ngValue]="c.nrInternoConta">
              #{{ c.nrInternoConta }} · atend. #{{ c.nrAtendimento }} · {{ c.dtPeriodoInicial }} · {{ formatCurrencyDash(c.vlConta) }}
            </option>
          </select>
        </label>
        <label *ngIf="contaAcaoTipoExclusao === 'outro'">
          <span class="rotulo-v2">Justificativa <span class="obrigatorio">*</span></span>
          <textarea [(ngModel)]="contaAcaoMotivo" rows="3" maxlength="1000" class="campo-v2" style="height: auto; padding: 10px 12px"></textarea>
          <span style="font-size: 11px; color: #8A6B12">{{ contaAcaoMotivo.trim().length }}/{{ MIN_JUSTIFICATIVA_OUTRO }} caracteres mínimos</span>
        </label>
      </ng-container>

      <!-- Trocar convênio -->
      <ng-container *ngIf="contaAcao.tipo === 'remover-cupom'">
        <div class="aviso-v2 ambar">
          Remover o cupom <strong>{{ contaAcaoCupons.length ? codigosCupons(contaAcaoCupons) : contaAcao.conta.cupomAplicado }}</strong> desta conta?
          O desconto<ng-container *ngIf="contaAcao.conta.vlDesconto > 0"> de {{ formatCurrencyDash(contaAcao.conta.vlDesconto) }}</ng-container>
          sai da conta e o cupom volta a ficar ativo para o paciente.
        </div>
      </ng-container>

      <ng-container *ngIf="contaAcao.tipo === 'trocar'">
        <div class="form-v2-grade" style="grid-template-columns: repeat(2, minmax(0, 1fr))">
          <label>
            <span class="rotulo-v2">Convênio <span class="obrigatorio">*</span></span>
            <select [(ngModel)]="contaAcaoConvenio" (ngModelChange)="onContaAcaoConvenioChange()" class="campo-v2">
              <option [ngValue]="null">Selecione</option>
              <option *ngFor="let c of contaAcaoConvenios" [ngValue]="c.cdConvenio">{{ c.dsConvenio }}</option>
            </select>
          </label>
          <label>
            <span class="rotulo-v2">Categoria <span class="obrigatorio">*</span></span>
            <select [(ngModel)]="contaAcaoCategoria" [disabled]="!contaAcaoCategorias.length" class="campo-v2">
              <option [ngValue]="null">Selecione</option>
              <option *ngFor="let c of contaAcaoCategorias" [ngValue]="c.cdCategoria">{{ c.dsCategoria }}</option>
            </select>
          </label>
        </div>
        <div class="aviso-v2 ambar">Os valores da conta são recalculados na tabela do convênio novo.</div>
        <label>
          <span class="rotulo-v2">Motivo <span class="obrigatorio">*</span></span>
          <textarea [(ngModel)]="contaAcaoMotivo" rows="2" maxlength="255" class="campo-v2" style="height: auto; padding: 10px 12px"></textarea>
        </label>
      </ng-container>

      <div *ngIf="contaAcaoErro" class="aviso-v2 vermelho">{{ contaAcaoErro }}</div>
    </div>

    <div class="flex items-center justify-end gap-2 px-7 py-4"
         style="border-top: 1px solid #EFE9DD; background-color: var(--flua-rodape); border-radius: 0 0 18px 18px">
      <button type="button" (click)="fecharAcaoConta()" [disabled]="contaAcaoEnviando"
              class="px-6 bg-white"
              style="height: 44px; border-radius: 10px; border: 1px solid var(--flua-borda); font-size: 14px; font-weight: 600; color: var(--tx-2)">
        Voltar
      </button>
      <button type="button" (click)="confirmarAcaoConta()" [disabled]="!contaAcaoPronta"
              class="px-6"
              style="height: 44px; border-radius: 10px; font-size: 14px; font-weight: 700"
              [style.background-color]="!contaAcaoPronta ? '#E5DFD4' : (contaAcao.tipo === 'trocar' ? 'var(--brand-primary)' : '#B4003C')"
              [style.color]="!contaAcaoPronta ? '#8796A1' : '#fff'"
              [style.cursor]="!contaAcaoPronta ? 'not-allowed' : 'pointer'">
        {{ contaAcaoEnviando ? 'Processando...' : botaoAcaoConta(contaAcao.tipo) }}
      </button>
    </div>
  </div>
</div>

<app-pagamento-especie-modal
  [aberto]="pgShowEspecie"
  [clinicId]="unitCode"
  [userName]="userName"
  [personId]="detalhesPaciente?.cdPessoaFisica ?? null"
  [valorConta]="pgDados?.vlSaldo ?? 0"
  [valorSugerido]="pgDados?.vlSaldo ?? pgDados?.vlTotalConta ?? 0"
  (fechar)="pgShowEspecie = false"
  (registrado)="pgOnEspecieRegistrado()"></app-pagamento-especie-modal>

<app-cadastro-paciente-modal [aberto]="showCadastroPaciente" [cpfInicial]="cpfDaBusca" [clinicId]="unitCode"
  (fechar)="showCadastroPaciente = false" (cadastrado)="onPacienteCadastrado($event)"></app-cadastro-paciente-modal>

<!-- Pagamento avulso embutido: o dashboard segue montado, com o hub vivo -->
<div
  *ngIf="showPagamentoAvulsoModal"
  class="fixed inset-0 z-[120] overflow-y-auto"
  style="background-color: rgba(16,24,32,.72); backdrop-filter: blur(6px)"
>
  <!-- min-h-full + items-center: centraliza quando cabe e vira scroll quando nao cabe -->
  <div class="flex min-h-full items-center justify-center p-4">
    <div class="w-full max-w-2xl">
      <app-pagamento-avulso
        [embutido]="true"
        [pacienteInicial]="pagamentoPaciente"
        (fechado)="onPagamentoAvulsoFechado($event)"
      ></app-pagamento-avulso>
    </div>
  </div>
</div>

<!-- Tooltip grupos do paciente -->
<div *ngIf="scoreTooltipDash"
     class="fixed z-[9999] bg-white rounded-xl shadow-xl p-3 pointer-events-none"
     style="min-width: 200px; border: 1px solid var(--flua-borda)"
     [ngStyle]="{ 'left.px': scoreTooltipDash.x, 'top.px': scoreTooltipDash.y }">
  <p class="text-[10px] font-bold uppercase tracking-wide mb-2" style="color: var(--tx-3)">Grupos</p>
  <div *ngFor="let item of scoreTooltipDash.groups" class="flex items-center gap-2 py-0.5">
    <span class="w-2 h-2 rounded-full flex-shrink-0" [ngStyle]="{ 'background-color': item.config.cor }"></span>
    <span class="text-xs flex-1" [ngStyle]="{ 'color': item.config.corText }">
      {{ item.config.label }}<span *ngIf="item.fator > 1" class="ml-0.5 font-extrabold">×{{ item.fator }}</span>
    </span>
    <span class="text-xs font-bold" style="color: var(--tx-2)">{{ item.weight }}</span>
  </div>
  <p *ngIf="scoreTooltipDash.groups.length === 0" class="text-xs" style="color: var(--tx-3)">Nenhum critério identificado</p>
  <div *ngIf="scoreTooltipDash.groups.length" class="flex items-center justify-between mt-2 pt-2" style="border-top: 1px solid #F4F1EA">
    <span class="text-[10px] font-bold uppercase tracking-wide" style="color: var(--tx-3)">Total</span>
    <span class="text-xs font-extrabold" style="color: var(--tx)">{{ scoreTooltipDash.total }}</span>
  </div>
</div>

<!-- ══ MODAL BLOQUEANTE — SANGRIA OBRIGATÓRIA (11:30 / 16:30) ═══════════════ -->
<div *ngIf="showSangriaBlock"
     class="fixed inset-0 z-[99999] flex items-center justify-center"
     style="background-color: rgba(0,0,0,0.75)">
  <div class="bg-white rounded-2xl shadow-2xl p-8 mx-4 text-center" style="max-width: 360px; width: 100%">
    <div class="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style="background-color: #ffedd5">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#c2410c" class="size-8">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
      </svg>
    </div>
    <h2 class="font-bold text-lg mb-2" style="color: #9a3412">Sangria necessária</h2>
    <p class="text-sm mb-1" style="color: var(--tx-2)">
      Seu caixa ultrapassou o limite de <strong>R$ 1.000,00</strong>.
    </p>
    <p class="text-sm mb-4" style="color: var(--tx-2)">
      Saldo atual: <strong style="color: #9a3412">{{ sangriaAlertSaldo | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</strong>
    </p>
    <p class="text-xs mb-6" style="color: var(--tx-3)">
      Realize uma sangria para continuar atendendo.
    </p>
    <button (click)="irParaSangria()"
            class="w-full py-3 rounded-xl text-sm font-bold text-white"
            style="background-color: #c2410c">
      Realizar Sangria agora
    </button>
  </div>
</div>

<!-- ══ TOAST — AVISO DE SANGRIA (após atendimento) ═══════════════════════ -->
<div *ngIf="showSangriaToast"
     class="fixed bottom-6 right-6 z-[9998] rounded-xl shadow-xl p-4 bg-white"
     style="max-width: 300px; border-left: 4px solid #f97316">
  <div class="flex items-start gap-3">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#f97316" class="size-5 flex-shrink-0 mt-0.5">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
    </svg>
    <div class="flex-1">
      <p class="text-xs font-bold mb-0.5" style="color: #9a3412">Atenção: verifique o caixa</p>
      <p class="text-xs mb-2" style="color: var(--tx-2)">
        Saldo: <strong>{{ sangriaAlertSaldo | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</strong>.
        Bloqueio às 11:30 e 16:30 se acima de R$&nbsp;1.000.
      </p>
      <button (click)="irParaSangria()"
              class="text-xs font-semibold underline"
              style="color: #c2410c">
        Ir para Sangria
      </button>
    </div>
    <button (click)="showSangriaToast = false"
            class="text-gray-400 hover:text-gray-600 p-0.5">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
</div>

<!-- *ngIf: fechar destrói a Agenda e para a atualização de 30 s da grade. -->
<app-agenda *ngIf="showAgenda" [inicial]="agendaInicial" [visaoInicial]="agendaVisaoInicial" [porBaixo]="agendaPorBaixo" (fechar)="showAgenda = false"
  [senhaChamada]="selectedCallPassword?.dsPassword ?? null" [chamadaAutomatica]="chamadaAutomaticaAgenda"
  (pausarChamada)="timerRef?.openPauseModal()"
  (abrirConta)="onAgendaConta($event)" (abrirHistorico)="onAgendaHistorico($event)"
  (abrirFilaMedica)="openVerFila($event)"></app-agenda>

<app-historico-paciente [aberto]="showHistorico" [pacienteInicial]="historicoPaciente" [username]="userName"
  [cdEmpresa]="cdEmpresaDaMarca" [supervisorConta]="!!supervisorConta" [pausado]="historicoPausado"
  [contasVersao]="historicoContasVersao" [avisoContas]="historicoAvisoContas" (fechar)="fecharHistorico()"
  (pagarConta)="onHistoricoPagar($event)" (vincularConta)="onHistoricoPagar($event, true)"
  (menuConta)="onHistoricoMenuConta($event)"
  (imprimirFicha)="onHistoricoFicha($event)"></app-historico-paciente>
